/* ============================================================
   BORDADOS ALICANTE · PARCHES
   ba-parches.js · V2 · VISUAL BORDADO

   BASE:
   - Mismo lenguaje visual y reglas principales del Bordado.
   - Varios parches dentro de una misma solicitud.
   - Autopresupuesto ESTIMADO en cliente.
   - Revisión posterior obligatoria por Bordados Alicante.

   REGLAS REUTILIZADAS DE BORDADO:
   - Dificultad:
       Fácil   5,00 €/ud
       Medio   7,00 €/ud
       Difícil 12,00 €/ud
   - Colores:
       1–2  +0 €/ud
       3–4  +1 €/ud
       5+   +2 €/ud
   - Descuento bordado:
       1–20  0%
       21–49 10%
       50+   15%
   - Picaje:
       1–20 uds por logo: 20 €
       21+ uds por logo: GRATIS

   TAMAÑO:
   - De 5 a 8 cm de lado mayor: sin coste adicional.
   - Más de 8 y hasta 12 cm: +1 €/ud.
   - Se deja explícito como estimación para revisión administrativa.

   IMPORTANTE:
   1) WEB_APP_URL se configurará cuando conectemos Parches.gs.
   2) El cliente ve una ESTIMACIÓN, no un precio aprobado.
   3) No toca el JS de Bordado/DTF.
   ============================================================ */

(function () {
  'use strict';

  var CONFIG = {
    WEB_APP_URL: 'https://script.google.com/macros/s/AKfycbx7z8LezCIFpIJeR5Ml4jE-thYOo1Vj3lWKRhyMlAe_q8s_euTdge_L2XY25WWLssnoJg/exec',

    CLOUDINARY_CLOUD_NAME: 'ddpczwdkg',
    CLOUDINARY_UPLOAD_PRESET: 'bordados_alicante_logos',
    MAX_FILE_BYTES: 5 * 1024 * 1024,

    MIN_QUANTITY: 1,
    MIN_SIZE_CM: 5,
    MAX_SIZE_CM: 12,
    DEFAULT_SIZE_CM: 8,

    DIFFICULTY_TIERS: [
      {
        key: 'facil',
        label: 'Parche fácil',
        shortLabel: 'Fácil',
        price: 5,
        tone: 'green',
        description: 'Logos simples, textos grandes y pocos detalles.',
        examples: ['Texto grande de empresa', 'Logo lineal de 1–2 colores', 'Símbolo sencillo sin detalles pequeños'],
        exampleImages: [
          'https://cdn.shopify.com/s/files/1/1017/1272/4297/files/ChatGPT_Image_22_ago_2026_21_17_21_1.png?v=1787430048',
          'https://cdn.shopify.com/s/files/1/1017/1272/4297/files/ChatGPT_Image_22_ago_2026_21_17_21_3.png?v=1787430048',
          'https://cdn.shopify.com/s/files/1/1017/1272/4297/files/ChatGPT_Image_22_ago_2026_21_17_21_2.png?v=1787430048'
        ]
      },
      {
        key: 'media',
        label: 'Parche medio',
        shortLabel: 'Medio',
        price: 7,
        tone: 'gold',
        description: 'Logos corporativos, varios colores o detalle medio.',
        examples: ['Logo de empresa con icono', 'Nombre + símbolo con detalle medio', 'Diseño con varios colores y formas definidas'],
        exampleImages: [
          'https://cdn.shopify.com/s/files/1/1017/1272/4297/files/ChatGPT_Image_22_ago_2026_21_24_06_4.png?v=1787430123',
          'https://cdn.shopify.com/s/files/1/1017/1272/4297/files/ChatGPT_Image_22_ago_2026_21_24_06_3.png?v=1787430124',
          'https://cdn.shopify.com/s/files/1/1017/1272/4297/files/ChatGPT_Image_22_ago_2026_21_24_06_1.png?v=1787430123'
        ]
      },
      {
        key: 'dificil',
        label: 'Parche difícil',
        shortLabel: 'Difícil',
        price: 11,
        tone: 'pink',
        description: 'Escudos, letras pequeñas, mucho relleno o muchos detalles.',
        examples: ['Escudo deportivo detallado', 'Logo con letra pequeña y varios colores', 'Emblema con relleno y detalles moderados'],
        exampleImages: [
          'https://cdn.shopify.com/s/files/1/1017/1272/4297/files/ChatGPT_Image_22_ago_2026_21_37_18_3.png?v=1787430164',
          'https://cdn.shopify.com/s/files/1/1017/1272/4297/files/ChatGPT_Image_22_ago_2026_21_37_17_2.png?v=1787430163',
          'https://cdn.shopify.com/s/files/1/1017/1272/4297/files/ChatGPT_Image_22_ago_2026_21_35_43.png?v=1787430163'
        ]
      }
    ],

    COLOR_OPTIONS: [
      {
        key: '1_2',
        label: '1–2 colores',
        help: 'Logos limpios, textos o diseños sencillos.',
        surcharge: 0
      },
      {
        key: '3_4',
        label: '3–4 colores',
        help: 'Logos corporativos con más detalle visual.',
        surcharge: 1
      },
      {
        key: '5_plus',
        label: '5+ colores',
        help: 'Escudos, emblemas o diseños más complejos.',
        surcharge: 2
      }
    ],

    SHAPES: [
      { key: 'redondo', label: 'Redondo', icon: 'circle' },
      { key: 'ovalado', label: 'Ovalado', icon: 'oval' },
      { key: 'cuadrado', label: 'Cuadrado', icon: 'square' },
      { key: 'rectangular', label: 'Rectangular', icon: 'rect' },
      { key: 'escudo', label: 'Escudo', icon: 'shield' }
    ],

    APPLICATION_OPTIONS: [
      {
        key: 'cosido_cliente',
        label: 'Cosido por el cliente',
        description: 'Te entregamos el parche listo para coser.',
        icon: '🧵'
      },
      {
        key: 'termoadhesivo',
        label: 'Termoadhesivo',
        description: 'Incluye base termoadhesiva para aplicar con calor.',
        icon: '♨️'
      }
    ],

    THERMO_SMALL_SURCHARGE: 0.20,
    THERMO_MEDIUM_SURCHARGE: 0.30,

    PICAGE_PRICE: 20,
    PICAGE_FREE_FROM: 21,

    SIZE_MEDIUM_FROM_EXCLUSIVE: 8,
    SIZE_MEDIUM_MAX: 12,
    SIZE_MEDIUM_SURCHARGE: 1
  };

  var STORAGE_KEY = 'ba_patch_quote_v4_sequential';

  /* ============================================================
     UTILIDADES
     ============================================================ */

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function roundEuros(value) {
    return Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
  }

  function euro(value) {
    return roundEuros(value).toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  function uid() {
    return 'PATCH-' +
      Date.now().toString(36).toUpperCase() + '-' +
      Math.random().toString(36).slice(2, 8).toUpperCase();
  }

  function clampNumber(value, min, max, fallback) {
    var n = Number(value);
    if (!Number.isFinite(n)) n = Number(fallback || min);
    return Math.min(max, Math.max(min, n));
  }

  function getDifficulty(key) {
    return CONFIG.DIFFICULTY_TIERS.find(function (item) {
      return item.key === key;
    }) || null;
  }

  function getColorOption(key) {
    return CONFIG.COLOR_OPTIONS.find(function (item) {
      return item.key === key;
    }) || null;
  }

  function getShape(key) {
    return CONFIG.SHAPES.find(function (item) {
      return item.key === key;
    }) || null;
  }

  function getApplication(key) {
    return CONFIG.APPLICATION_OPTIONS.find(function (item) {
      return item.key === key;
    }) || null;
  }

  function getApplicationSurcharge(patch) {
    if (patch.application !== 'termoadhesivo') return 0;

    var largest = Math.max(
      Number(patch.widthCm || 0),
      Number(patch.heightCm || 0)
    );

    return largest <= 8
      ? CONFIG.THERMO_SMALL_SURCHARGE
      : CONFIG.THERMO_MEDIUM_SURCHARGE;
  }

  function getApplicationLabel(patch) {
    var application = getApplication(patch.application);
    if (!application) return 'Sin seleccionar';

    if (patch.application === 'termoadhesivo') {
      return application.label + ' · +' + euro(getApplicationSurcharge(patch)) + '/ud';
    }

    return application.label + ' · sin coste adicional';
  }

  function getQuantityDiscountPercent(quantity) {
    var qty = Math.max(1, Math.floor(Number(quantity || 1)));
    if (qty >= 50) return 15;
    if (qty >= 21) return 10;
    return 0;
  }

  function getQuantityDiscountLabel(quantity) {
    var qty = Math.max(1, Math.floor(Number(quantity || 1)));
    if (qty >= 50) return '50+ uds';
    if (qty >= 21) return '21–49 uds';
    return '1–20 uds';
  }

  function getNextDiscountHint(quantity) {
    var qty = Math.max(1, Math.floor(Number(quantity || 1)));

    if (qty < 21) {
      return {
        missing: 21 - qty,
        discount: 10
      };
    }

    if (qty < 50) {
      return {
        missing: 50 - qty,
        discount: 15
      };
    }

    return null;
  }

  function getSizeSurcharge(patch) {
    var largest = Math.max(
      Number(patch.widthCm || 0),
      Number(patch.heightCm || 0)
    );

    if (
      largest > CONFIG.SIZE_MEDIUM_FROM_EXCLUSIVE &&
      largest <= CONFIG.SIZE_MEDIUM_MAX
    ) {
      return CONFIG.SIZE_MEDIUM_SURCHARGE;
    }

    return 0;
  }

  function getSizeLabel(patch) {
    var largest = Math.max(
      Number(patch.widthCm || 0),
      Number(patch.heightCm || 0)
    );

    if (largest > CONFIG.SIZE_MEDIUM_FROM_EXCLUSIVE) {
      return 'Mediano · +1 €/ud';
    }

    return 'Pequeño · sin coste adicional';
  }

  function calculatePatch(patch) {
    var difficulty = getDifficulty(patch.difficulty);
    var colors = getColorOption(patch.colors);
    var quantity = Math.max(1, Math.floor(Number(patch.quantity || 1)));
    var sizeSurcharge = getSizeSurcharge(patch);
    var applicationSurcharge = getApplicationSurcharge(patch);

    var originalUnitPrice = roundEuros(
      Number(difficulty ? difficulty.price : 0) +
      Number(colors ? colors.surcharge : 0) +
      Number(sizeSurcharge || 0) +
      Number(applicationSurcharge || 0)
    );

    var discountPercent = getQuantityDiscountPercent(quantity);
    var unitPrice = roundEuros(
      originalUnitPrice * (100 - discountPercent) / 100
    );

    var embroideryTotal = roundEuros(unitPrice * quantity);
    var picage = quantity >= CONFIG.PICAGE_FREE_FROM
      ? 0
      : CONFIG.PICAGE_PRICE;

    var total = roundEuros(embroideryTotal + picage);

    return {
      quantity: quantity,
      difficulty: difficulty,
      colors: colors,
      sizeSurcharge: sizeSurcharge,
      sizeLabel: getSizeLabel(patch),
      applicationSurcharge: applicationSurcharge,
      application: getApplication(patch.application),
      originalUnitPrice: originalUnitPrice,
      unitPrice: unitPrice,
      discountPercent: discountPercent,
      discountLabel: getQuantityDiscountLabel(quantity),
      embroideryTotal: embroideryTotal,
      picage: picage,
      picageFree: picage === 0,
      totalBeforeDiscount: roundEuros(originalUnitPrice * quantity + picage),
      discountTotal: roundEuros((originalUnitPrice - unitPrice) * quantity),
      total: total
    };
  }

  function calculateOrder(state) {
    var items = state.patches.map(function (patch) {
      return calculatePatch(patch);
    });

    var productionBeforeDiscount = roundEuros(
      items.reduce(function (sum, item) {
        return sum + (item.originalUnitPrice * item.quantity);
      }, 0)
    );

    var embroideryTotal = roundEuros(
      items.reduce(function (sum, item) {
        return sum + item.embroideryTotal;
      }, 0)
    );

    var picageTotal = roundEuros(
      items.reduce(function (sum, item) {
        return sum + item.picage;
      }, 0)
    );

    var paidPicages = items.filter(function (item) {
      return item.picage > 0;
    }).length;

    var freePicages = items.length - paidPicages;

    var potentialPicageTotal = roundEuros(
      items.length * CONFIG.PICAGE_PRICE
    );

    var discountTotal = roundEuros(
      items.reduce(function (sum, item) {
        return sum + item.discountTotal;
      }, 0)
    );

    var total = roundEuros(embroideryTotal + picageTotal);

    return {
      items: items,
      units: state.patches.reduce(function (sum, patch) {
        return sum + Math.max(1, Math.floor(Number(patch.quantity || 1)));
      }, 0),

      productionBeforeDiscount: productionBeforeDiscount,
      embroideryTotal: embroideryTotal,

      picageTotal: picageTotal,
      potentialPicageTotal: potentialPicageTotal,
      paidPicages: paidPicages,
      freePicages: freePicages,

      discountTotal: discountTotal,

      totalBeforeDiscount: roundEuros(
        productionBeforeDiscount + picageTotal
      ),

      total: total
    };
  }

  /* ============================================================
     ESTADO
     ============================================================ */

  function blankPatch() {
    return {
      id: uid(),

      logoUrl: '',
      logoName: '',
      logoFingerprint: '',

      difficulty: '',
      colors: '',

      shape: '',
      application: '',
      widthCm: CONFIG.DEFAULT_SIZE_CM,
      heightCm: CONFIG.DEFAULT_SIZE_CM,

      quantity: 10,
      notes: ''
    };
  }

  function readState() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');

      return {
        patches: Array.isArray(parsed.patches) && parsed.patches.length
          ? parsed.patches.map(function (patch) {
              var merged = Object.assign(blankPatch(), patch || {});
              if (merged.shape === 'personalizada') merged.shape = '';
              merged.widthCm = clampNumber(merged.widthCm, CONFIG.MIN_SIZE_CM, CONFIG.MAX_SIZE_CM, CONFIG.DEFAULT_SIZE_CM);
              merged.heightCm = clampNumber(merged.heightCm, CONFIG.MIN_SIZE_CM, CONFIG.MAX_SIZE_CM, CONFIG.DEFAULT_SIZE_CM);
              return merged;
            })
          : [blankPatch()],

        customer: parsed.customer || {}
      };
    } catch (_) {
      return {
        patches: [blankPatch()],
        customer: {}
      };
    }
  }

  function saveState(state) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  }

  /* ============================================================
     CLOUDINARY
     ============================================================ */

  function fingerprintFile(file) {
    return [
      file.name,
      file.size,
      file.type,
      file.lastModified
    ].join('|');
  }

  function uploadToCloudinary(file) {
    if (!file) {
      return Promise.reject(new Error('Selecciona un archivo.'));
    }

    if (file.size > CONFIG.MAX_FILE_BYTES) {
      return Promise.reject(
        new Error('El archivo supera el máximo de 5 MB.')
      );
    }

    var form = new FormData();
    form.append('file', file);
    form.append('upload_preset', CONFIG.CLOUDINARY_UPLOAD_PRESET);

    return fetch(
      'https://api.cloudinary.com/v1_1/' +
      encodeURIComponent(CONFIG.CLOUDINARY_CLOUD_NAME) +
      '/auto/upload',
      {
        method: 'POST',
        body: form
      }
    ).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || !data.secure_url) {
          throw new Error(
            data.error && data.error.message
              ? data.error.message
              : 'No se pudo subir el diseño.'
          );
        }

        return data;
      });
    });
  }

  /* ============================================================
     APPS SCRIPT
     ============================================================ */

  function post(payload) {
    if (
      !CONFIG.WEB_APP_URL ||
      CONFIG.WEB_APP_URL.indexOf('PEGA_AQUI') !== -1
    ) {
      return Promise.reject(
        new Error(
          'La solicitud todavía no está conectada al flujo. ' +
          'Estamos terminando la configuración.'
        )
      );
    }

    return fetch(CONFIG.WEB_APP_URL, {
      method: 'POST',
      redirect: 'follow',
      headers: {
        'Content-Type': 'text/plain;charset=utf-8'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.text().then(function (text) {
        var data;

        try {
          data = JSON.parse(text || '{}');
        } catch (_) {
          throw new Error('Respuesta inválida del servidor.');
        }

        if (!response.ok || !data.ok) {
          throw new Error(
            data.error || 'No se pudo enviar la solicitud.'
          );
        }

        return data;
      });
    });
  }

  /* ============================================================
     ICONOS DE FORMA
     ============================================================ */

  function shapeSvg(type) {
    if (type === 'circle') {
      return '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="14"/></svg>';
    }

    if (type === 'oval') {
      return '<svg viewBox="0 0 48 48" aria-hidden="true"><ellipse cx="24" cy="24" rx="17" ry="11"/></svg>';
    }

    if (type === 'square') {
      return '<svg viewBox="0 0 48 48" aria-hidden="true"><rect x="10" y="10" width="28" height="28" rx="3"/></svg>';
    }

    if (type === 'rect') {
      return '<svg viewBox="0 0 48 48" aria-hidden="true"><rect x="7" y="14" width="34" height="20" rx="3"/></svg>';
    }

    if (type === 'shield') {
      return '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 7 38 12v10c0 9-5.5 15.3-14 19-8.5-3.7-14-10-14-19V12Z"/></svg>';
    }

    return '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M8 27c4-11 10-17 18-18 7 3 10 8 14 16-4 10-11 14-21 14C13 36 10 32 8 27Z"/></svg>';
  }

  /* ============================================================
     ESTILOS
     ============================================================ */

  function injectStyles() {
    if (document.getElementById('baPatchesStylesV2')) return;

    var style = document.createElement('style');
    style.id = 'baPatchesStylesV2';

    style.textContent = `
      .ba-patches-v2{
        --ba-pink:#e91458;
        --ba-pink-dark:#b50c43;
        --ba-pink-soft:#fff0f5;
        --ba-green:#15803d;
        --ba-green-soft:#eaf8ef;
        --ba-gold:#9a6b00;
        --ba-gold-soft:#fff7db;
        --ba-ink:#151024;
        --ba-muted:#756970;
        --ba-line:#eadde2;
        --ba-soft:#fffafb;
        max-width:1180px;
        margin:24px auto 60px;
        padding:0 16px;
        color:var(--ba-ink);
        font-family:inherit;
      }

      .ba-patches-v2 *{box-sizing:border-box}

      .ba-patches-hero{
        display:flex;
        align-items:flex-end;
        justify-content:space-between;
        gap:20px;
        margin-bottom:18px;
      }

      .ba-patches-kicker{
        display:inline-flex;
        align-items:center;
        gap:7px;
        border-radius:999px;
        background:var(--ba-pink-soft);
        color:var(--ba-pink);
        padding:7px 10px;
        font-size:11px;
        font-weight:950;
        letter-spacing:.04em;
        text-transform:uppercase;
      }

      .ba-patches-hero h1{
        margin:8px 0 4px;
        font-size:34px;
        line-height:1.05;
        font-weight:950;
        letter-spacing:-.03em;
      }

      .ba-patches-hero p{
        margin:0;
        color:var(--ba-muted);
        font-size:13px;
        font-weight:750;
        line-height:1.45;
      }

      .ba-patches-btn{
        border:0;
        border-radius:12px;
        padding:12px 16px;
        font:inherit;
        font-weight:950;
        cursor:pointer;
        transition:transform .15s ease,box-shadow .15s ease,background .15s ease;
      }

      .ba-patches-btn:hover{transform:translateY(-1px)}

      .ba-patches-btn--primary{
        background:var(--ba-pink);
        color:#fff;
        box-shadow:0 10px 20px rgba(233,20,88,.18);
      }

      .ba-patches-btn--secondary{
        background:#fff;
        color:var(--ba-ink);
        border:1px solid var(--ba-line);
      }

      .ba-patches-btn--ghost{
        background:var(--ba-pink-soft);
        color:var(--ba-pink-dark);
      }

      .ba-patches-list{
        display:grid;
        gap:18px;
      }

      .ba-patch-v2{
        background:#fff;
        border:1px solid var(--ba-line);
        border-radius:22px;
        overflow:hidden;
        box-shadow:0 14px 34px rgba(34,17,26,.055);
      }

      .ba-patch-v2__head{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:14px;
        padding:14px 16px;
        background:linear-gradient(90deg,#fff3f7 0%,#fff 72%);
        border-bottom:1px solid #f0dbe3;
      }

      .ba-patch-v2__title{
        display:flex;
        align-items:center;
        gap:10px;
        min-width:0;
      }

      .ba-patch-v2__number{
        width:34px;
        height:34px;
        border-radius:10px;
        display:flex;
        align-items:center;
        justify-content:center;
        background:var(--ba-pink);
        color:#fff;
        font-size:14px;
        font-weight:950;
        flex:0 0 auto;
      }

      .ba-patch-v2__title strong{
        display:block;
        font-size:16px;
        font-weight:950;
      }

      .ba-patch-v2__title small{
        display:block;
        margin-top:2px;
        color:var(--ba-muted);
        font-size:10px;
        font-weight:800;
      }

      .ba-patch-remove{
        border:0;
        border-radius:999px;
        background:#fff0f4;
        color:#b50c43;
        padding:8px 11px;
        font:inherit;
        font-size:10px;
        font-weight:950;
        cursor:pointer;
      }

      .ba-patch-v2__body{
        display:grid;
        grid-template-columns:minmax(0,1.35fr) minmax(290px,.65fr);
        gap:16px;
        padding:16px;
      }

      .ba-patch-config{
        min-width:0;
      }

      .ba-patch-summary{
        min-width:0;
        align-self:start;
        position:sticky;
        top:18px;
      }

      .ba-step-card{
        border:1px solid var(--ba-line);
        border-radius:17px;
        background:#fff;
        padding:14px;
        margin-bottom:12px;
      }

      .ba-step-head{
        display:flex;
        align-items:flex-start;
        justify-content:space-between;
        gap:12px;
        margin-bottom:11px;
      }

      .ba-step-head__left{
        display:flex;
        gap:9px;
        align-items:flex-start;
      }

      .ba-step-number{
        width:27px;
        height:27px;
        border-radius:8px;
        display:flex;
        align-items:center;
        justify-content:center;
        background:var(--ba-pink-soft);
        color:var(--ba-pink);
        font-size:11px;
        font-weight:950;
        flex:0 0 auto;
      }

      .ba-step-head strong{
        display:block;
        font-size:14px;
        font-weight:950;
      }

      .ba-step-head p{
        margin:3px 0 0;
        color:var(--ba-muted);
        font-size:10.5px;
        font-weight:750;
        line-height:1.35;
      }

      .ba-difficulty-grid{
        display:grid;
        grid-template-columns:repeat(3,minmax(0,1fr));
        gap:8px;
      }

      .ba-difficulty{
        position:relative;
        border:1px solid var(--ba-line);
        border-radius:14px;
        background:#fff;
        padding:10px;
        text-align:left;
        cursor:pointer;
        font:inherit;
        min-height:132px;
        transition:.15s ease;
      }

      .ba-difficulty:hover{
        transform:translateY(-1px);
        border-color:#efbfd0;
      }

      .ba-difficulty.is-active{
        border:2px solid var(--ba-pink);
        background:#fff5f8;
        box-shadow:0 7px 18px rgba(233,20,88,.11);
        padding:9px;
      }

      .ba-difficulty__top{
        display:flex;
        align-items:center;
        gap:8px;
      }

      .ba-difficulty__icon{
        width:34px;
        height:34px;
        border-radius:10px;
        display:flex;
        align-items:center;
        justify-content:center;
        font-size:16px;
        flex:0 0 auto;
      }

      .ba-difficulty--green .ba-difficulty__icon{
        background:var(--ba-green-soft);
      }

      .ba-difficulty--gold .ba-difficulty__icon{
        background:var(--ba-gold-soft);
      }

      .ba-difficulty--pink .ba-difficulty__icon{
        background:var(--ba-pink-soft);
      }

      .ba-difficulty__top b{
        display:block;
        font-size:12px;
        font-weight:950;
      }

      .ba-difficulty__top small{
        display:block;
        margin-top:2px;
        color:var(--ba-muted);
        font-size:8px;
        font-weight:850;
      }

      .ba-difficulty p{
        margin:8px 0 0;
        color:#665a61;
        font-size:9px;
        line-height:1.35;
        font-weight:750;
      }

      .ba-difficulty__choose{
        display:inline-flex;
        margin-top:8px;
        color:var(--ba-pink);
        font-size:9px;
        font-weight:950;
      }

      .ba-colors-grid{
        display:grid;
        grid-template-columns:repeat(3,minmax(0,1fr));
        gap:8px;
      }

      .ba-color-option{
        border:1px solid var(--ba-line);
        border-radius:13px;
        background:#fff;
        padding:11px;
        text-align:left;
        font:inherit;
        cursor:pointer;
        transition:.15s ease;
      }

      .ba-color-option.is-active{
        border:2px solid var(--ba-pink);
        background:#fff5f8;
        padding:10px;
      }

      .ba-color-option b{
        display:block;
        color:var(--ba-ink);
        font-size:11px;
        font-weight:950;
      }

      .ba-color-option span{
        display:block;
        margin-top:4px;
        color:var(--ba-muted);
        font-size:8.5px;
        line-height:1.35;
        font-weight:750;
      }

      .ba-shapes-grid{
        display:grid;
        grid-template-columns:repeat(6,minmax(0,1fr));
        gap:7px;
      }

      .ba-shape{
        border:1px solid var(--ba-line);
        border-radius:12px;
        background:#fff;
        padding:8px 5px;
        text-align:center;
        font:inherit;
        cursor:pointer;
        transition:.15s ease;
      }

      .ba-shape.is-active{
        border:2px solid var(--ba-pink);
        background:#fff5f8;
        padding:7px 4px;
      }

      .ba-shape svg{
        width:34px;
        height:34px;
        fill:none;
        stroke:currentColor;
        stroke-width:2;
        color:#7a6871;
      }

      .ba-shape.is-active svg{color:var(--ba-pink)}

      .ba-shape span{
        display:block;
        margin-top:4px;
        font-size:8px;
        font-weight:900;
      }

      .ba-size-grid{
        display:grid;
        grid-template-columns:repeat(2,minmax(0,1fr));
        gap:9px;
        margin-top:11px;
      }

      .ba-field{
        display:flex;
        flex-direction:column;
        gap:5px;
      }

      .ba-field label{
        color:#564951;
        font-size:10px;
        font-weight:950;
      }

      .ba-field input,
      .ba-field textarea{
        width:100%;
        min-width:0;
        border:1px solid #dfd4da;
        border-radius:10px;
        background:#fff;
        padding:10px 11px;
        color:var(--ba-ink);
        font:inherit;
        font-size:12px;
        font-weight:800;
        outline:none;
      }

      .ba-field input:focus,
      .ba-field textarea:focus{
        border-color:var(--ba-pink);
        box-shadow:0 0 0 3px rgba(233,20,88,.08);
      }

      .ba-field textarea{
        resize:vertical;
        min-height:74px;
        font-weight:650;
      }

      .ba-size-note{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:10px;
        margin-top:9px;
        padding:8px 10px;
        border-radius:10px;
        background:#fff8fa;
        border:1px solid #f0dbe3;
        color:#6f5e67;
        font-size:9px;
        font-weight:850;
      }

      .ba-size-note b{color:var(--ba-pink)}

      .ba-upload-wrap{
        display:grid;
        grid-template-columns:130px minmax(0,1fr);
        gap:12px;
        align-items:center;
      }

      .ba-upload-preview{
        width:130px;
        height:130px;
        border:1px dashed #d9c5cf;
        border-radius:15px;
        background:#fffafb;
        display:flex;
        align-items:center;
        justify-content:center;
        overflow:hidden;
      }

      .ba-upload-preview img{
        width:100%;
        height:100%;
        object-fit:contain;
        display:block;
      }

      .ba-upload-preview__empty{
        text-align:center;
        color:#9a8891;
        padding:12px;
      }

      .ba-upload-preview__empty strong{
        display:block;
        font-size:26px;
        line-height:1;
      }

      .ba-upload-preview__empty span{
        display:block;
        margin-top:7px;
        font-size:9px;
        font-weight:850;
      }

      .ba-upload-control input[type=file]{
        width:100%;
        padding:9px;
        border:1px solid var(--ba-line);
        border-radius:10px;
        background:#fff;
        font-size:10px;
      }

      .ba-upload-control small{
        display:block;
        margin-top:6px;
        color:var(--ba-muted);
        font-size:8.5px;
        line-height:1.35;
        font-weight:750;
      }

      .ba-qty-card{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
        margin-top:11px;
        padding:10px 11px;
        border:1px solid var(--ba-line);
        border-radius:12px;
        background:#fffafb;
      }

      .ba-qty-card strong{
        display:block;
        font-size:11px;
        font-weight:950;
      }

      .ba-qty-card small{
        display:block;
        margin-top:2px;
        color:var(--ba-muted);
        font-size:8.5px;
        font-weight:800;
      }

      .ba-qty-side{
        display:flex;
        align-items:center;
        justify-content:flex-end;
        gap:9px;
        flex-wrap:wrap;
      }

      .ba-qty-discount-hint{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        max-width:220px;
        padding:6px 9px;
        border:1px solid #b5e4c5;
        border-radius:999px;
        background:#eaf8ef;
        color:#15803d;
        font-size:9px;
        line-height:1.2;
        font-weight:950;
        text-align:center;
        white-space:nowrap;
      }

      .ba-qty-discount-hint.is-max{
        background:#eaf8ef;
        color:#15803d;
      }

      .ba-qty-control{
        display:grid;
        grid-template-columns:30px 54px 30px;
        gap:4px;
        align-items:center;
        flex:0 0 auto;
      }

      .ba-qty-control button{
        width:30px;
        height:30px;
        border:1px solid #efc7d6;
        border-radius:8px;
        background:#fff;
        color:var(--ba-pink);
        font-size:16px;
        font-weight:950;
        cursor:pointer;
      }

      .ba-qty-control input{
        width:54px;
        height:30px;
        border:1px solid var(--ba-line);
        border-radius:8px;
        text-align:center;
        color:var(--ba-ink);
        font-size:11px;
        font-weight:950;
        appearance:textfield;
        -moz-appearance:textfield;
      }

      .ba-qty-control input::-webkit-outer-spin-button,
      .ba-qty-control input::-webkit-inner-spin-button{
        -webkit-appearance:none;
        margin:0;
      }

      .ba-estimate{
        border:1px solid #f0c9d7;
        border-radius:17px;
        overflow:hidden;
        background:#fff;
      }

      .ba-estimate__head{
        padding:12px 13px;
        background:linear-gradient(90deg,#fff3f7 0%,#fff 100%);
        border-bottom:1px solid #f0dbe3;
      }

      .ba-estimate__head small{
        display:block;
        color:var(--ba-muted);
        font-size:8.5px;
        text-transform:uppercase;
        letter-spacing:.05em;
        font-weight:900;
      }

      .ba-estimate__head strong{
        display:block;
        margin-top:3px;
        font-size:16px;
        font-weight:950;
      }

      .ba-estimate__body{
        padding:11px 13px 13px;
      }

      .ba-estimate-row{
        display:flex;
        align-items:flex-start;
        justify-content:space-between;
        gap:12px;
        padding:7px 0;
        border-bottom:1px solid #f3e8ed;
        font-size:10px;
      }

      .ba-estimate-row:last-child{border-bottom:0}

      .ba-estimate-row span{
        color:#6c5d65;
        font-weight:800;
      }

      .ba-estimate-row b{
        text-align:right;
        color:var(--ba-ink);
        font-weight:950;
      }

      .ba-estimate-row--green b{color:var(--ba-green)}

      .ba-estimate-price{
        margin-top:10px;
        padding:11px;
        border-radius:13px;
        background:#151024;
        color:#fff;
      }

      .ba-estimate-price__unit{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:10px;
      }

      .ba-estimate-price__unit span{
        font-size:10px;
        font-weight:800;
        opacity:.78;
      }

      .ba-estimate-price__unit b{
        font-size:17px;
        font-weight:950;
      }

      .ba-estimate-price__old{
        display:block;
        margin-top:3px;
        text-align:right;
        font-size:9px;
        opacity:.65;
        text-decoration:line-through;
      }

      .ba-estimate-total{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:10px;
        margin-top:9px;
        padding-top:9px;
        border-top:1px solid rgba(255,255,255,.18);
      }

      .ba-estimate-total span{
        font-size:11px;
        font-weight:900;
      }

      .ba-estimate-total b{
        color:#ff78aa;
        font-size:23px;
        font-weight:950;
      }

      .ba-next-discount{
        display:block;
        margin-top:8px;
        border-radius:9px;
        background:#eefbf2;
        color:#176a34;
        padding:7px 8px;
        font-size:8.5px;
        font-weight:900;
        line-height:1.3;
      }

      .ba-picage{
        margin-top:10px;
        border:1px solid var(--ba-line);
        border-radius:14px;
        padding:10px;
        background:#fff;
      }

      .ba-picage__head{
        display:flex;
        align-items:flex-start;
        justify-content:space-between;
        gap:8px;
      }

      .ba-picage__head strong{
        display:block;
        font-size:11px;
        font-weight:950;
      }

      .ba-picage__head small{
        display:block;
        margin-top:2px;
        color:var(--ba-muted);
        font-size:8px;
        line-height:1.35;
        font-weight:800;
      }

      .ba-picage__badge{
        border-radius:999px;
        padding:5px 7px;
        background:var(--ba-pink-soft);
        color:var(--ba-pink);
        font-size:8px;
        font-weight:950;
        white-space:nowrap;
      }

      .ba-picage.is-free{
        border-color:#bfe3cb;
        background:#f6fff8;
      }

      .ba-picage.is-free .ba-picage__badge{
        background:#dff5e6;
        color:var(--ba-green);
      }

      .ba-order-summary{
        margin-top:18px;
        display:grid;
        grid-template-columns:minmax(0,1fr) 360px;
        gap:16px;
        align-items:start;
      }

      .ba-customer{
        border:1px solid var(--ba-line);
        border-radius:19px;
        background:#fff;
        padding:16px;
      }

      .ba-customer h2{
        margin:0 0 4px;
        font-size:18px;
        font-weight:950;
      }

      .ba-customer>p{
        margin:0 0 13px;
        color:var(--ba-muted);
        font-size:10px;
        font-weight:750;
      }

      .ba-customer-grid{
        display:grid;
        grid-template-columns:repeat(2,minmax(0,1fr));
        gap:9px;
      }

      .ba-global-summary{
        border:1px solid #f0c9d7;
        border-radius:19px;
        overflow:hidden;
        background:#fff;
        box-shadow:0 14px 30px rgba(233,20,88,.06);
      }

      .ba-global-summary__head{
        padding:13px 14px;
        background:linear-gradient(90deg,#fff0f5,#fff);
        border-bottom:1px solid #f0dbe3;
      }

      .ba-global-summary__head strong{
        display:block;
        font-size:15px;
        font-weight:950;
      }

      .ba-global-summary__head small{
        display:block;
        margin-top:3px;
        color:var(--ba-muted);
        font-size:9px;
        font-weight:800;
      }

      .ba-global-summary__body{padding:12px 14px}

      .ba-global-line{
        display:flex;
        justify-content:space-between;
        gap:12px;
        padding:7px 0;
        border-bottom:1px solid #f2e5ea;
        font-size:10px;
      }

      .ba-global-line span{
        color:#6e5f67;
        font-weight:800;
      }

      .ba-global-line b{
        font-weight:950;
      }

      .ba-global-line--saving b{color:var(--ba-green)}

      .ba-global-total{
        display:flex;
        justify-content:space-between;
        align-items:flex-end;
        gap:12px;
        margin-top:12px;
      }

      .ba-global-total span{
        font-size:11px;
        font-weight:900;
      }

      .ba-global-total b{
        color:var(--ba-pink);
        font-size:26px;
        line-height:1;
        font-weight:950;
      }

      .ba-review-note{
        margin-top:10px;
        padding:9px 10px;
        border-radius:11px;
        background:#fff8e8;
        color:#71560b;
        font-size:8.5px;
        line-height:1.4;
        font-weight:850;
      }

      .ba-actions{
        display:flex;
        gap:8px;
        justify-content:flex-end;
        margin-top:11px;
      }

      .ba-status{
        display:none;
        margin-top:10px;
        border-radius:10px;
        padding:10px 11px;
        font-size:10px;
        font-weight:850;
      }

      .ba-status.is-ok{
        display:block;
        background:#eefbf2;
        color:#176a34;
      }

      .ba-status.is-error{
        display:block;
        background:#fff0f4;
        color:#a91f4e;
      }

      @media(max-width:980px){
        .ba-patch-v2__body{
          grid-template-columns:1fr;
        }

        .ba-patch-summary{
          position:static;
        }

        .ba-order-summary{
          grid-template-columns:1fr;
        }

        .ba-global-summary{
          order:-1;
        }
      }

      @media(max-width:720px){
        .ba-qty-card{
          align-items:flex-start;
        }

        .ba-qty-side{
          width:100%;
          justify-content:flex-end;
        }

        .ba-qty-discount-hint{
          white-space:normal;
          max-width:180px;
        }

        .ba-patches-v2{
          margin-top:16px;
          padding:0 10px;
        }

        .ba-patches-hero{
          align-items:flex-start;
          flex-direction:column;
        }

        .ba-patches-hero h1{
          font-size:27px;
        }

        .ba-difficulty-grid,
        .ba-colors-grid{
          grid-template-columns:1fr;
        }

        .ba-shapes-grid{
          grid-template-columns:repeat(3,minmax(0,1fr));
        }

        .ba-upload-wrap{
          grid-template-columns:90px minmax(0,1fr);
        }

        .ba-upload-preview{
          width:90px;
          height:90px;
        }

        .ba-customer-grid,
        .ba-size-grid{
          grid-template-columns:1fr;
        }

        .ba-actions{
          flex-direction:column;
        }

        .ba-actions .ba-patches-btn{
          width:100%;
        }
      }
    `;


    document.head.appendChild(style);

    /* BA PARCHES V2.1 — EXPANSIÓN VISUAL PC
       Conserva exactamente el diseño V2, pero aprovecha mejor el ancho
       de pantalla y aumenta textos, tarjetas, controles y resumen. */
    var desktopStyle = document.createElement('style');
    desktopStyle.id = 'baPatchesDesktopExpandedV21';
    desktopStyle.textContent = `
      @media(min-width:1000px){
        .ba-patches-v2{
          max-width:1480px!important;
          margin:30px auto 70px!important;
          padding:0 24px!important;
        }

        .ba-patches-hero{
          gap:28px!important;
          margin-bottom:24px!important;
        }

        .ba-patches-kicker{
          padding:9px 13px!important;
          font-size:13px!important;
        }

        .ba-patches-hero h1{
          margin:11px 0 7px!important;
          font-size:43px!important;
        }

        .ba-patches-hero p{
          max-width:900px!important;
          font-size:16px!important;
          line-height:1.5!important;
        }

        .ba-patches-btn{
          border-radius:14px!important;
          padding:15px 20px!important;
          font-size:14px!important;
        }

        .ba-patches-list{
          gap:24px!important;
        }

        .ba-patch-v2{
          border-radius:24px!important;
        }

        .ba-patch-v2__head{
          padding:18px 21px!important;
        }

        .ba-patch-v2__number{
          width:42px!important;
          height:42px!important;
          border-radius:12px!important;
          font-size:17px!important;
        }

        .ba-patch-v2__title{
          gap:13px!important;
        }

        .ba-patch-v2__title strong{
          font-size:20px!important;
        }

        .ba-patch-v2__title small{
          margin-top:4px!important;
          font-size:12px!important;
        }

        .ba-patch-remove{
          padding:10px 14px!important;
          font-size:12px!important;
        }

        .ba-patch-v2__body{
          grid-template-columns:minmax(0,1.45fr) minmax(380px,.55fr)!important;
          gap:22px!important;
          padding:21px!important;
        }

        .ba-step-card{
          border-radius:19px!important;
          padding:18px!important;
          margin-bottom:16px!important;
        }

        .ba-step-head{
          margin-bottom:15px!important;
        }

        .ba-step-head__left{
          gap:11px!important;
        }

        .ba-step-number{
          width:34px!important;
          height:34px!important;
          border-radius:10px!important;
          font-size:14px!important;
        }

        .ba-step-head strong{
          font-size:17px!important;
        }

        .ba-step-head p{
          margin-top:5px!important;
          font-size:13px!important;
          line-height:1.45!important;
        }

        .ba-difficulty-grid,
        .ba-colors-grid{
          gap:11px!important;
        }

        .ba-difficulty{
          border-radius:16px!important;
          padding:14px!important;
          min-height:170px!important;
        }

        .ba-difficulty.is-active{
          padding:13px!important;
        }

        .ba-difficulty__top{
          gap:10px!important;
        }

        .ba-difficulty__icon{
          width:43px!important;
          height:43px!important;
          border-radius:12px!important;
          font-size:20px!important;
        }

        .ba-difficulty__top b{
          font-size:15px!important;
        }

        .ba-difficulty__top small{
          font-size:10px!important;
        }

        .ba-difficulty p{
          margin-top:11px!important;
          font-size:12px!important;
          line-height:1.45!important;
        }

        .ba-difficulty__choose{
          margin-top:10px!important;
          font-size:11px!important;
        }

        .ba-color-option{
          border-radius:15px!important;
          padding:15px!important;
          min-height:90px!important;
        }

        .ba-color-option.is-active{
          padding:14px!important;
        }

        .ba-color-option b{
          font-size:14px!important;
        }

        .ba-color-option span{
          margin-top:6px!important;
          font-size:11px!important;
          line-height:1.4!important;
        }

        .ba-shapes-grid{
          gap:10px!important;
        }

        .ba-shape{
          border-radius:14px!important;
          padding:12px 7px!important;
          min-height:94px!important;
        }

        .ba-shape.is-active{
          padding:11px 6px!important;
        }

        .ba-shape svg{
          width:43px!important;
          height:43px!important;
        }

        .ba-shape span{
          margin-top:6px!important;
          font-size:10.5px!important;
        }

        .ba-size-grid{
          gap:12px!important;
          margin-top:15px!important;
        }

        .ba-field{
          gap:7px!important;
        }

        .ba-field label{
          font-size:12.5px!important;
        }

        .ba-field input,
        .ba-field textarea{
          border-radius:12px!important;
          padding:13px 14px!important;
          font-size:14px!important;
        }

        .ba-field textarea{
          min-height:96px!important;
        }

        .ba-size-note{
          margin-top:12px!important;
          padding:11px 13px!important;
          border-radius:12px!important;
          font-size:11px!important;
        }

        .ba-upload-wrap{
          grid-template-columns:165px minmax(0,1fr)!important;
          gap:17px!important;
        }

        .ba-upload-preview{
          width:165px!important;
          height:165px!important;
          border-radius:18px!important;
        }

        .ba-upload-preview__empty strong{
          font-size:34px!important;
        }

        .ba-upload-preview__empty span{
          margin-top:9px!important;
          font-size:11px!important;
        }

        .ba-upload-control input[type=file]{
          padding:12px!important;
          border-radius:12px!important;
          font-size:12px!important;
        }

        .ba-upload-control small{
          margin-top:8px!important;
          font-size:10.5px!important;
        }

        .ba-qty-card{
          margin-top:15px!important;
          padding:13px 15px!important;
          border-radius:14px!important;
        }

        .ba-qty-card strong{
          font-size:14px!important;
        }

        .ba-qty-card small{
          margin-top:4px!important;
          font-size:10.5px!important;
        }

        .ba-qty-discount-hint{
          padding:8px 11px!important;
          font-size:11px!important;
        }

        .ba-qty-control{
          grid-template-columns:38px 66px 38px!important;
          gap:5px!important;
        }

        .ba-qty-control button{
          width:38px!important;
          height:38px!important;
          border-radius:9px!important;
          font-size:20px!important;
        }

        .ba-qty-control input{
          width:66px!important;
          height:38px!important;
          border-radius:9px!important;
          font-size:14px!important;
        }

        .ba-estimate{
          border-radius:19px!important;
        }

        .ba-estimate__head{
          padding:15px 16px!important;
        }

        .ba-estimate__head small{
          font-size:10px!important;
        }

        .ba-estimate__head strong{
          margin-top:4px!important;
          font-size:20px!important;
        }

        .ba-estimate__body{
          padding:14px 16px 16px!important;
        }

        .ba-estimate-row{
          gap:15px!important;
          padding:10px 0!important;
          font-size:12.5px!important;
        }

        .ba-estimate-price{
          margin-top:13px!important;
          padding:14px!important;
          border-radius:15px!important;
        }

        .ba-estimate-price__unit span{
          font-size:12px!important;
        }

        .ba-estimate-price__unit b{
          font-size:22px!important;
        }

        .ba-estimate-price__old{
          margin-top:4px!important;
          font-size:11px!important;
        }

        .ba-estimate-total{
          margin-top:12px!important;
          padding-top:12px!important;
        }

        .ba-estimate-total span{
          font-size:14px!important;
        }

        .ba-estimate-total b{
          font-size:30px!important;
        }

        .ba-next-discount{
          margin-top:11px!important;
          padding:9px 10px!important;
          font-size:10.5px!important;
        }

        .ba-picage{
          margin-top:13px!important;
          border-radius:16px!important;
          padding:13px!important;
        }

        .ba-picage__head strong{
          font-size:13px!important;
        }

        .ba-picage__head small{
          margin-top:4px!important;
          font-size:10px!important;
        }

        .ba-picage__badge{
          padding:6px 9px!important;
          font-size:10px!important;
        }

        .ba-order-summary{
          margin-top:24px!important;
          grid-template-columns:minmax(0,1fr) 440px!important;
          gap:22px!important;
        }

        .ba-customer{
          border-radius:21px!important;
          padding:20px!important;
        }

        .ba-customer h2{
          font-size:23px!important;
        }

        .ba-customer>p{
          margin-bottom:16px!important;
          font-size:12px!important;
        }

        .ba-customer-grid{
          gap:12px!important;
        }

        .ba-global-summary{
          border-radius:21px!important;
        }

        .ba-global-summary__head{
          padding:16px 17px!important;
        }

        .ba-global-summary__head strong{
          font-size:19px!important;
        }

        .ba-global-summary__head small{
          margin-top:4px!important;
          font-size:11px!important;
        }

        .ba-global-summary__body{
          padding:15px 17px!important;
        }

        .ba-global-line{
          padding:10px 0!important;
          font-size:12.5px!important;
        }

        .ba-global-total{
          margin-top:15px!important;
        }

        .ba-global-total span{
          font-size:14px!important;
        }

        .ba-global-total b{
          font-size:34px!important;
        }

        .ba-review-note{
          margin-top:13px!important;
          padding:11px 12px!important;
          border-radius:13px!important;
          font-size:10.5px!important;
          line-height:1.5!important;
        }

        .ba-actions{
          gap:10px!important;
          margin-top:14px!important;
        }

        .ba-status{
          margin-top:12px!important;
          padding:12px 13px!important;
          font-size:12px!important;
        }
      }
    `;
    document.head.appendChild(desktopStyle);
  }


    /* BA PARCHES V2.2 — +15% VISUAL EN PC
       Mantiene la misma proporción/composición de V2.1.
       Solo aumenta aproximadamente un 15% tamaños, tipografías,
       controles y espacios en escritorio. */
    var desktopScaleStyle = document.createElement('style');
    desktopScaleStyle.id = 'baPatchesDesktopScale115V22';
    desktopScaleStyle.textContent = `
      @media(min-width:1000px){
        .ba-patches-v2{
          max-width:1700px!important;
          padding:0 28px!important;
        }

        .ba-patches-hero{
          gap:32px!important;
          margin-bottom:28px!important;
        }

        .ba-patches-kicker{
          padding:10px 15px!important;
          font-size:15px!important;
        }

        .ba-patches-hero h1{
          margin:13px 0 8px!important;
          font-size:49px!important;
        }

        .ba-patches-hero p{
          max-width:1035px!important;
          font-size:18px!important;
        }

        .ba-patches-btn{
          border-radius:16px!important;
          padding:17px 23px!important;
          font-size:16px!important;
        }

        .ba-patches-list{
          gap:28px!important;
        }

        .ba-patch-v2{
          border-radius:28px!important;
        }

        .ba-patch-v2__head{
          padding:21px 24px!important;
        }

        .ba-patch-v2__number{
          width:48px!important;
          height:48px!important;
          border-radius:14px!important;
          font-size:20px!important;
        }

        .ba-patch-v2__title{
          gap:15px!important;
        }

        .ba-patch-v2__title strong{
          font-size:23px!important;
        }

        .ba-patch-v2__title small{
          margin-top:5px!important;
          font-size:14px!important;
        }

        .ba-patch-remove{
          padding:12px 16px!important;
          font-size:14px!important;
        }

        .ba-patch-v2__body{
          grid-template-columns:minmax(0,1.45fr) minmax(437px,.55fr)!important;
          gap:25px!important;
          padding:24px!important;
        }

        .ba-step-card{
          border-radius:22px!important;
          padding:21px!important;
          margin-bottom:18px!important;
        }

        .ba-step-head{
          margin-bottom:17px!important;
        }

        .ba-step-head__left{
          gap:13px!important;
        }

        .ba-step-number{
          width:39px!important;
          height:39px!important;
          border-radius:12px!important;
          font-size:16px!important;
        }

        .ba-step-head strong{
          font-size:20px!important;
        }

        .ba-step-head p{
          margin-top:6px!important;
          font-size:15px!important;
        }

        .ba-difficulty-grid,
        .ba-colors-grid{
          gap:13px!important;
        }

        .ba-difficulty{
          border-radius:18px!important;
          padding:16px!important;
          min-height:196px!important;
        }

        .ba-difficulty.is-active{
          padding:15px!important;
        }

        .ba-difficulty__top{
          gap:12px!important;
        }

        .ba-difficulty__icon{
          width:49px!important;
          height:49px!important;
          border-radius:14px!important;
          font-size:23px!important;
        }

        .ba-difficulty__top b{
          font-size:17px!important;
        }

        .ba-difficulty__top small{
          font-size:12px!important;
        }

        .ba-difficulty p{
          margin-top:13px!important;
          font-size:14px!important;
        }

        .ba-difficulty__choose{
          margin-top:12px!important;
          font-size:13px!important;
        }

        .ba-color-option{
          border-radius:17px!important;
          padding:17px!important;
          min-height:104px!important;
        }

        .ba-color-option.is-active{
          padding:16px!important;
        }

        .ba-color-option b{
          font-size:16px!important;
        }

        .ba-color-option span{
          margin-top:7px!important;
          font-size:13px!important;
        }

        .ba-shapes-grid{
          gap:12px!important;
        }

        .ba-shape{
          border-radius:16px!important;
          padding:14px 8px!important;
          min-height:108px!important;
        }

        .ba-shape.is-active{
          padding:13px 7px!important;
        }

        .ba-shape svg{
          width:49px!important;
          height:49px!important;
        }

        .ba-shape span{
          margin-top:7px!important;
          font-size:12px!important;
        }

        .ba-size-grid{
          gap:14px!important;
          margin-top:17px!important;
        }

        .ba-field{
          gap:8px!important;
        }

        .ba-field label{
          font-size:14px!important;
        }

        .ba-field input,
        .ba-field textarea{
          border-radius:14px!important;
          padding:15px 16px!important;
          font-size:16px!important;
        }

        .ba-field textarea{
          min-height:110px!important;
        }

        .ba-size-note{
          margin-top:14px!important;
          padding:13px 15px!important;
          border-radius:14px!important;
          font-size:13px!important;
        }

        .ba-upload-wrap{
          grid-template-columns:190px minmax(0,1fr)!important;
          gap:20px!important;
        }

        .ba-upload-preview{
          width:190px!important;
          height:190px!important;
          border-radius:21px!important;
        }

        .ba-upload-preview__empty strong{
          font-size:39px!important;
        }

        .ba-upload-preview__empty span{
          margin-top:10px!important;
          font-size:13px!important;
        }

        .ba-upload-control input[type=file]{
          padding:14px!important;
          border-radius:14px!important;
          font-size:14px!important;
        }

        .ba-upload-control small{
          margin-top:9px!important;
          font-size:12px!important;
        }

        .ba-qty-card{
          margin-top:17px!important;
          padding:15px 17px!important;
          border-radius:16px!important;
        }

        .ba-qty-card strong{
          font-size:16px!important;
        }

        .ba-qty-card small{
          margin-top:5px!important;
          font-size:12px!important;
        }

        .ba-qty-control{
          grid-template-columns:44px 76px 44px!important;
          gap:6px!important;
        }

        .ba-qty-control button{
          width:44px!important;
          height:44px!important;
          border-radius:10px!important;
          font-size:23px!important;
        }

        .ba-qty-control input{
          width:76px!important;
          height:44px!important;
          border-radius:10px!important;
          font-size:16px!important;
        }

        .ba-estimate{
          border-radius:22px!important;
        }

        .ba-estimate__head{
          padding:17px 18px!important;
        }

        .ba-estimate__head small{
          font-size:12px!important;
        }

        .ba-estimate__head strong{
          margin-top:5px!important;
          font-size:23px!important;
        }

        .ba-estimate__body{
          padding:16px 18px 18px!important;
        }

        .ba-estimate-row{
          gap:17px!important;
          padding:12px 0!important;
          font-size:14px!important;
        }

        .ba-estimate-price{
          margin-top:15px!important;
          padding:16px!important;
          border-radius:17px!important;
        }

        .ba-estimate-price__unit span{
          font-size:14px!important;
        }

        .ba-estimate-price__unit b{
          font-size:25px!important;
        }

        .ba-estimate-price__old{
          margin-top:5px!important;
          font-size:13px!important;
        }

        .ba-estimate-total{
          margin-top:14px!important;
          padding-top:14px!important;
        }

        .ba-estimate-total span{
          font-size:16px!important;
        }

        .ba-estimate-total b{
          font-size:35px!important;
        }

        .ba-next-discount{
          margin-top:13px!important;
          padding:10px 12px!important;
          font-size:12px!important;
        }

        .ba-picage{
          margin-top:15px!important;
          border-radius:18px!important;
          padding:15px!important;
        }

        .ba-picage__head strong{
          font-size:15px!important;
        }

        .ba-picage__head small{
          margin-top:5px!important;
          font-size:12px!important;
        }

        .ba-picage__badge{
          padding:7px 10px!important;
          font-size:12px!important;
        }

        .ba-order-summary{
          margin-top:28px!important;
          grid-template-columns:minmax(0,1fr) 506px!important;
          gap:25px!important;
        }

        .ba-customer{
          border-radius:24px!important;
          padding:23px!important;
        }

        .ba-customer h2{
          font-size:26px!important;
        }

        .ba-customer>p{
          margin-bottom:18px!important;
          font-size:14px!important;
        }

        .ba-customer-grid{
          gap:14px!important;
        }

        .ba-global-summary{
          border-radius:24px!important;
        }

        .ba-global-summary__head{
          padding:18px 20px!important;
        }

        .ba-global-summary__head strong{
          font-size:22px!important;
        }

        .ba-global-summary__head small{
          margin-top:5px!important;
          font-size:13px!important;
        }

        .ba-global-summary__body{
          padding:17px 20px!important;
        }

        .ba-global-line{
          padding:12px 0!important;
          font-size:14px!important;
        }

        .ba-global-total{
          margin-top:17px!important;
        }

        .ba-global-total span{
          font-size:16px!important;
        }

        .ba-global-total b{
          font-size:39px!important;
        }

        .ba-review-note{
          margin-top:15px!important;
          padding:13px 14px!important;
          border-radius:15px!important;
          font-size:12px!important;
        }

        .ba-actions{
          gap:12px!important;
          margin-top:16px!important;
        }

        .ba-status{
          margin-top:14px!important;
          padding:14px 15px!important;
          font-size:14px!important;
        }
      }
    `;
    document.head.appendChild(desktopScaleStyle);


    /* BA PARCHES V2.3 — TEXTOS MÁS GRANDES EN PC
       Mantiene exactamente la estructura y proporciones actuales.
       Solo mejora la legibilidad aumentando tipografías. */
    var desktopTextStyle = document.createElement('style');
    desktopTextStyle.id = 'baPatchesDesktopTextV23';
    desktopTextStyle.textContent = `
      @media(min-width:1000px){
        .ba-patches-hero p{font-size:21px!important;line-height:1.55!important}
        .ba-patches-kicker{font-size:17px!important}
        .ba-patches-btn{font-size:18px!important}

        .ba-patch-v2__title strong{font-size:27px!important}
        .ba-patch-v2__title small{font-size:16px!important}
        .ba-patch-remove{font-size:15px!important}

        .ba-step-number{font-size:18px!important}
        .ba-step-head strong{font-size:23px!important}
        .ba-step-head p{font-size:17px!important;line-height:1.5!important}

        .ba-difficulty__top b{font-size:20px!important}
        .ba-difficulty__top small{font-size:14px!important}
        .ba-difficulty p{font-size:16px!important;line-height:1.5!important}
        .ba-difficulty__choose{font-size:15px!important}

        .ba-color-option b{font-size:18px!important}
        .ba-color-option span{font-size:15px!important;line-height:1.45!important}

        .ba-shape span{font-size:14px!important}

        .ba-field label{font-size:16px!important}
        .ba-field input,
        .ba-field textarea{font-size:18px!important}

        .ba-size-note{font-size:15px!important}

        .ba-upload-preview__empty span{font-size:15px!important}
        .ba-upload-control input[type=file]{font-size:16px!important}
        .ba-upload-control small{font-size:14px!important;line-height:1.45!important}

        .ba-qty-card strong{font-size:18px!important}
        .ba-qty-card small{font-size:14px!important;line-height:1.45!important}
        .ba-qty-control input{font-size:18px!important}

        .ba-estimate__head small{font-size:14px!important}
        .ba-estimate__head strong{font-size:27px!important}
        .ba-estimate-row{font-size:16px!important}
        .ba-estimate-price__unit span{font-size:16px!important}
        .ba-estimate-price__unit b{font-size:29px!important}
        .ba-estimate-price__old{font-size:15px!important}
        .ba-estimate-total span{font-size:18px!important}
        .ba-estimate-total b{font-size:39px!important}
        .ba-next-discount{font-size:14px!important;line-height:1.45!important}

        .ba-picage__head strong{font-size:17px!important}
        .ba-picage__head small{font-size:14px!important;line-height:1.45!important}
        .ba-picage__badge{font-size:14px!important}

        .ba-customer h2{font-size:30px!important}
        .ba-customer>p{font-size:16px!important;line-height:1.5!important}

        .ba-global-summary__head strong{font-size:25px!important}
        .ba-global-summary__head small{font-size:15px!important}
        .ba-global-line{font-size:16px!important}
        .ba-global-total span{font-size:18px!important}
        .ba-global-total b{font-size:43px!important}
        .ba-review-note{font-size:14px!important;line-height:1.55!important}
        .ba-status{font-size:16px!important}
      }
    `;
    document.head.appendChild(desktopTextStyle);


    /* BA PARCHES V2.4 — TEXTOS MUY GRANDES EN PC
       Conserva la distribución actual.
       Aumenta de forma marcada la legibilidad sin cambiar la lógica. */
    var desktopTextXLStyle = document.createElement('style');
    desktopTextXLStyle.id = 'baPatchesDesktopTextXLV24';
    desktopTextXLStyle.textContent = `
      @media(min-width:1000px){
        .ba-patches-hero h1{font-size:56px!important}
        .ba-patches-hero p{font-size:24px!important;line-height:1.6!important}
        .ba-patches-kicker{font-size:19px!important}
        .ba-patches-btn{font-size:20px!important}

        .ba-patch-v2__title strong{font-size:31px!important}
        .ba-patch-v2__title small{font-size:19px!important}
        .ba-patch-remove{font-size:17px!important}

        .ba-step-number{font-size:21px!important}
        .ba-step-head strong{font-size:27px!important}
        .ba-step-head p{font-size:20px!important;line-height:1.55!important}

        .ba-difficulty__top b{font-size:23px!important}
        .ba-difficulty__top small{font-size:17px!important}
        .ba-difficulty p{font-size:19px!important;line-height:1.55!important}
        .ba-difficulty__choose{font-size:17px!important}

        .ba-color-option b{font-size:21px!important}
        .ba-color-option span{font-size:18px!important;line-height:1.5!important}

        .ba-shape span{font-size:17px!important}

        .ba-field label{font-size:19px!important}
        .ba-field input,
        .ba-field textarea{font-size:20px!important}

        .ba-size-note{font-size:18px!important}

        .ba-upload-preview__empty span{font-size:18px!important}
        .ba-upload-control input[type=file]{font-size:18px!important}
        .ba-upload-control small{font-size:17px!important;line-height:1.5!important}

        .ba-qty-card strong{font-size:21px!important}
        .ba-qty-card small{font-size:17px!important;line-height:1.5!important}
        .ba-qty-control input{font-size:20px!important}

        .ba-estimate__head small{font-size:17px!important}
        .ba-estimate__head strong{font-size:31px!important}
        .ba-estimate-row{font-size:19px!important}
        .ba-estimate-price__unit span{font-size:19px!important}
        .ba-estimate-price__unit b{font-size:34px!important}
        .ba-estimate-price__old{font-size:17px!important}
        .ba-estimate-total span{font-size:21px!important}
        .ba-estimate-total b{font-size:45px!important}
        .ba-next-discount{font-size:17px!important;line-height:1.5!important}

        .ba-picage__head strong{font-size:20px!important}
        .ba-picage__head small{font-size:17px!important;line-height:1.5!important}
        .ba-picage__badge{font-size:16px!important}

        .ba-customer h2{font-size:34px!important}
        .ba-customer>p{font-size:19px!important;line-height:1.55!important}

        .ba-global-summary__head strong{font-size:29px!important}
        .ba-global-summary__head small{font-size:18px!important}
        .ba-global-line{font-size:19px!important}
        .ba-global-total span{font-size:21px!important}
        .ba-global-total b{font-size:49px!important}
        .ba-review-note{font-size:17px!important;line-height:1.6!important}
        .ba-status{font-size:18px!important}
      }
    `;
    document.head.appendChild(desktopTextXLStyle);


    /* BA PARCHES V2.5 — AJUSTES VISUALES DE PRECIO / PICAJE */
    var priceUiStyle = document.createElement('style');
    priceUiStyle.id = 'baPatchesPriceUiV25';
    priceUiStyle.textContent = `
      .ba-discount-badge{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        min-width:46px;
        padding:5px 9px;
        border-radius:999px;
        background:#e6f7ec;
        color:#15803d;
        font-weight:950;
      }

      .ba-picage-inline{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
        margin:10px 0 2px;
        padding:9px 10px;
        border-radius:10px;
        background:#eaf8ef;
        color:#176a34;
        font-weight:900;
      }

      .ba-picage-inline__label{
        font-size:11px;
        line-height:1.3;
      }

      .ba-picage-inline__value{
        display:inline-flex;
        align-items:center;
        gap:7px;
        white-space:nowrap;
      }

      .ba-picage-inline__value b{
        color:#151024;
        font-weight:950;
      }

      .ba-picage-inline.is-free .ba-picage-inline__value s{
        color:#9a8f95;
        text-decoration-thickness:2px;
      }

      .ba-picage-inline.is-free .ba-picage-inline__value b{
        color:#15803d;
      }

      .ba-price-stack,
      .ba-total-stack{
        display:flex;
        flex-direction:column;
        align-items:flex-end;
        gap:3px;
      }

      .ba-price-current{
        color:#fff;
        font-size:22px;
        font-weight:950;
        line-height:1;
      }

      .ba-price-current.is-discounted{
        color:#4ade80;
      }

      .ba-price-before{
        color:#a6a0aa;
        font-size:11px;
        font-weight:850;
        text-decoration:line-through;
        text-decoration-thickness:2px;
      }

      .ba-total-current{
        color:#ff78aa;
        font-size:30px;
        font-weight:950;
        line-height:1;
      }

      .ba-total-current.is-discounted{
        color:#4ade80;
      }

      .ba-total-before{
        color:#a6a0aa;
        font-size:12px;
        font-weight:850;
        text-decoration:line-through;
        text-decoration-thickness:2px;
      }

      @media(min-width:1000px){
        .ba-discount-badge{
          min-width:62px!important;
          padding:7px 12px!important;
          font-size:17px!important;
        }

        .ba-picage-inline{
          margin:13px 0 4px!important;
          padding:12px 13px!important;
          border-radius:12px!important;
        }

        .ba-picage-inline__label{
          font-size:16px!important;
        }

        .ba-picage-inline__value{
          gap:9px!important;
          font-size:17px!important;
        }

        .ba-price-current{
          font-size:34px!important;
        }

        .ba-price-before{
          font-size:16px!important;
        }

        .ba-total-current{
          font-size:45px!important;
        }

        .ba-total-before{
          font-size:17px!important;
        }
      }
    `;
    document.head.appendChild(priceUiStyle);


    /* BA PARCHES V2.6 — DESCUENTO Y PICAJE EN LÍNEA */
    var summaryLineStyle = document.createElement('style');
    summaryLineStyle.id = 'baPatchesSummaryLineV26';
    summaryLineStyle.textContent = `
      .ba-picage-inline,
      .ba-next-discount{
        display:none!important;
      }

      .ba-estimate-row--discount{
        align-items:center!important;
      }

      .ba-discount-line{
        display:flex;
        align-items:center;
        justify-content:flex-end;
        gap:8px;
        flex-wrap:wrap;
        text-align:right;
      }

      .ba-discount-value-green{
        color:#15803d;
        font-weight:950;
        white-space:nowrap;
      }

      .ba-discount-zero{
        color:#151024!important;
        font-weight:950;
      }

      .ba-discount-hint-inline{
        display:inline-flex;
        align-items:center;
        border-radius:999px;
        background:#eaf8ef;
        color:#176a34;
        padding:5px 8px;
        font-size:9px;
        line-height:1.25;
        font-weight:900;
        white-space:nowrap;
      }

      .ba-discount-hint-inline.is-max{
        background:#eaf8ef;
        color:#15803d;
      }

      .ba-picage-value-free{
        display:inline-flex;
        align-items:center;
        gap:7px;
        color:#151024;
        font-weight:950;
      }

      .ba-picage-value-free s{
        color:#9a8f95;
        text-decoration-thickness:2px;
      }

      .ba-picage-value-free b{
        color:#15803d;
      }

      @media(min-width:1000px){
        .ba-discount-line{
          gap:10px!important;
        }

        .ba-discount-value-green,
        .ba-discount-zero{
          font-size:19px!important;
        }

        .ba-discount-hint-inline{
          padding:7px 10px!important;
          font-size:13px!important;
        }

        .ba-picage-value-free{
          gap:9px!important;
          font-size:19px!important;
        }
      }

      @media(max-width:720px){
        .ba-estimate-row--discount{
          align-items:flex-start!important;
        }

        .ba-discount-line{
          max-width:68%;
        }

        .ba-discount-hint-inline{
          white-space:normal;
        }
      }
    `;
    document.head.appendChild(summaryLineStyle);


    /* BA PARCHES V2.7 — RESUMEN NEGRO + VERDE */
    var summaryBlackGreenStyle = document.createElement('style');
    summaryBlackGreenStyle.id = 'baPatchesSummaryBlackGreenV27';
    summaryBlackGreenStyle.textContent = `
      .ba-estimate-row > span:first-child,
      .ba-estimate-row .ba-summary-label-strong{
        color:#151024!important;
        font-weight:950!important;
      }

      .ba-estimate-row > b,
      .ba-estimate-row > span:last-child{
        color:#151024;
      }

      .ba-discount-label-wrap{
        display:flex!important;
        align-items:center!important;
        gap:7px!important;
        min-width:0;
        flex:1 1 auto;
      }

      .ba-discount-inline-note{
        display:inline!important;
        padding:0!important;
        margin:0!important;
        border:0!important;
        background:transparent!important;
        color:#15803d!important;
        font-size:8px!important;
        line-height:1.2!important;
        font-weight:950!important;
        white-space:nowrap!important;
      }

      .ba-discount-inline-note.is-max{
        color:#15803d!important;
      }

      .ba-discount-percent-badge{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        min-width:44px!important;
        padding:4px 8px!important;
        border-radius:999px!important;
        background:#e6f7ec!important;
        color:#15803d!important;
        font-weight:950!important;
        white-space:nowrap!important;
      }

      .ba-discount-zero{
        color:#151024!important;
        font-weight:950!important;
      }

      .ba-picage-simple{
        display:inline-flex!important;
        align-items:center!important;
        gap:7px!important;
        font-weight:950!important;
        white-space:nowrap!important;
      }

      .ba-picage-simple s{
        color:#9a8f95!important;
        text-decoration-thickness:2px!important;
      }

      .ba-picage-simple b{
        color:#15803d!important;
        font-weight:950!important;
      }

      .ba-picage-paid{
        color:#151024!important;
        font-weight:950!important;
      }

      @media(min-width:1000px){
        .ba-estimate-row > span:first-child,
        .ba-estimate-row .ba-summary-label-strong{
          font-size:19px!important;
        }

        .ba-estimate-row > b,
        .ba-estimate-row > span:last-child{
          font-size:19px!important;
        }

        .ba-discount-label-wrap{
          gap:8px!important;
        }

        .ba-discount-inline-note{
          font-size:10.5px!important;
        }

        .ba-discount-percent-badge{
          min-width:58px!important;
          padding:6px 10px!important;
          font-size:17px!important;
        }

        .ba-picage-simple,
        .ba-picage-paid{
          font-size:19px!important;
        }
      }

      @media(max-width:720px){
        .ba-discount-label-wrap{
          align-items:flex-start!important;
          flex-direction:column!important;
          gap:3px!important;
        }

        .ba-discount-inline-note{
          white-space:normal!important;
          font-size:8px!important;
        }
      }
    `;
    document.head.appendChild(summaryBlackGreenStyle);


    /* BA PARCHES V2.8 — ETIQUETAS DESCUENTO Y PICAJE BIEN CUADRADAS */
    var summaryBadgeStyle = document.createElement('style');
    summaryBadgeStyle.id = 'baPatchesSummaryBadgeV28';
    summaryBadgeStyle.textContent = `
      .ba-summary-inline-group{
        display:flex!important;
        align-items:center!important;
        justify-content:flex-end!important;
        gap:6px!important;
        min-width:0!important;
        flex-wrap:nowrap!important;
      }

      .ba-discount-hint-badge,
      .ba-picage-hint-badge{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        border-radius:999px!important;
        background:#eaf8ef!important;
        color:#15803d!important;
        padding:4px 7px!important;
        font-size:8px!important;
        line-height:1.15!important;
        font-weight:950!important;
        white-space:nowrap!important;
      }

      .ba-discount-hint-badge.is-max,
      .ba-picage-hint-badge.is-free{
        background:#eaf8ef!important;
        color:#15803d!important;
      }

      .ba-discount-percent-badge{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        min-width:46px!important;
        padding:4px 8px!important;
        border-radius:999px!important;
        background:#dff5e6!important;
        color:#15803d!important;
        font-weight:950!important;
        white-space:nowrap!important;
      }

      .ba-picage-simple{
        display:inline-flex!important;
        align-items:center!important;
        gap:5px!important;
        white-space:nowrap!important;
      }

      .ba-picage-simple s{
        color:#9a8f95!important;
        text-decoration-thickness:2px!important;
      }

      .ba-picage-simple b{
        color:#15803d!important;
        font-weight:950!important;
      }

      .ba-picage-paid{
        color:#151024!important;
        font-weight:950!important;
        white-space:nowrap!important;
      }

      @media(min-width:1000px){
        .ba-summary-inline-group{
          gap:7px!important;
        }

        .ba-discount-hint-badge,
        .ba-picage-hint-badge{
          padding:5px 8px!important;
          font-size:10px!important;
        }

        .ba-discount-percent-badge{
          min-width:54px!important;
          padding:6px 9px!important;
          font-size:17px!important;
        }

        .ba-picage-simple,
        .ba-picage-paid{
          font-size:19px!important;
        }
      }

      @media(max-width:720px){
        .ba-summary-inline-group{
          flex-wrap:wrap!important;
          justify-content:flex-end!important;
        }

        .ba-discount-hint-badge,
        .ba-picage-hint-badge{
          white-space:normal!important;
          text-align:center!important;
        }
      }
    `;
    document.head.appendChild(summaryBadgeStyle);


    /* BA PARCHES V2.9 — ETIQUETAS PEGADAS A LA IZQUIERDA */
    var summaryLeftBadgesStyle = document.createElement('style');
    summaryLeftBadgesStyle.id = 'baPatchesSummaryLeftBadgesV29';
    summaryLeftBadgesStyle.textContent = `
      .ba-estimate-row--discount,
      .ba-estimate-row:has(.ba-picage-hint-badge){
        display:grid!important;
        grid-template-columns:auto 1fr auto!important;
        align-items:center!important;
        column-gap:7px!important;
      }

      .ba-estimate-row--discount > .ba-summary-label-strong,
      .ba-estimate-row:has(.ba-picage-hint-badge) > .ba-summary-label-strong{
        grid-column:1!important;
      }

      .ba-estimate-row--discount > .ba-summary-inline-group,
      .ba-estimate-row:has(.ba-picage-hint-badge) > .ba-summary-inline-group{
        grid-column:2 / 4!important;
        display:grid!important;
        grid-template-columns:1fr auto!important;
        align-items:center!important;
        gap:7px!important;
        width:100%!important;
      }

      .ba-discount-hint-badge,
      .ba-picage-hint-badge{
        justify-self:start!important;
        margin-left:0!important;
      }

      .ba-discount-percent-badge,
      .ba-discount-zero,
      .ba-picage-simple,
      .ba-picage-paid{
        justify-self:end!important;
      }

      @media(max-width:720px){
        .ba-estimate-row--discount,
        .ba-estimate-row:has(.ba-picage-hint-badge){
          grid-template-columns:auto 1fr!important;
          row-gap:5px!important;
        }

        .ba-estimate-row--discount > .ba-summary-inline-group,
        .ba-estimate-row:has(.ba-picage-hint-badge) > .ba-summary-inline-group{
          grid-column:1 / 3!important;
          padding-left:0!important;
        }
      }
    `;
    document.head.appendChild(summaryLeftBadgesStyle);


    /* BA PARCHES V3.0 — PRECIOS GLOBAL + TOTAL PARCHE */
    var globalPriceStyle = document.createElement('style');
    globalPriceStyle.id = 'baPatchesGlobalPriceV30';
    globalPriceStyle.textContent = `
      /* Total de cada parche:
         sin descuento = blanco; con descuento = verde + anterior gris tachado */
      .ba-total-current:not(.is-discounted){
        color:#fff!important;
      }

      .ba-global-price-stack,
      .ba-global-total-stack{
        display:flex!important;
        flex-direction:column!important;
        align-items:flex-end!important;
        gap:3px!important;
      }

      .ba-global-price-stack s,
      .ba-global-total-stack s,
      .ba-global-picage-stack s{
        color:#9a8f95!important;
        font-weight:850!important;
        text-decoration-thickness:2px!important;
      }

      .ba-global-price-stack b.is-discounted,
      .ba-global-total-stack b,
      .ba-global-picage-stack b{
        color:#15803d!important;
        font-weight:950!important;
      }

      .ba-global-price-normal,
      .ba-global-total-normal{
        color:#151024!important;
        font-weight:950!important;
      }

      .ba-global-picage-stack{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:flex-end!important;
        gap:7px!important;
        white-space:nowrap!important;
      }

      .ba-global-picage-mixed{
        display:flex!important;
        align-items:flex-end!important;
        flex-direction:column!important;
        gap:3px!important;
        text-align:right!important;
      }

      .ba-global-picage-mixed small{
        color:#15803d!important;
        font-weight:900!important;
      }

      .ba-global-picage-mixed b{
        color:#151024!important;
        font-weight:950!important;
      }

      @media(min-width:1000px){
        .ba-global-price-stack s,
        .ba-global-picage-stack s{
          font-size:15px!important;
        }

        .ba-global-price-stack b,
        .ba-global-price-normal,
        .ba-global-picage-stack b,
        .ba-global-picage-mixed b{
          font-size:19px!important;
        }

        .ba-global-picage-mixed small{
          font-size:11px!important;
        }

        .ba-global-total-stack s{
          font-size:17px!important;
        }

        .ba-global-total-stack b,
        .ba-global-total-normal{
          font-size:39px!important;
          line-height:1!important;
        }
      }
    `;
    document.head.appendChild(globalPriceStyle);


    /* BA PARCHES V3.1 — RESUMEN GLOBAL LIMPIO */
    var globalSummaryCleanStyle = document.createElement('style');
    globalSummaryCleanStyle.id = 'baPatchesGlobalSummaryCleanV31';
    globalSummaryCleanStyle.textContent = `
      .ba-global-picage-detail{
        padding-bottom:8px;
        border-bottom:1px solid #f2e5ea;
      }

      .ba-global-picage-detail__title{
        color:#151024;
        font-weight:950;
        margin-bottom:6px;
      }

      .ba-global-picage-detail-row{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
        padding:5px 0;
      }

      .ba-global-picage-detail-row span{
        color:#6e5f67;
        font-weight:850;
      }

      .ba-global-picage-detail-row b{
        color:#151024;
        font-weight:950;
      }

      .ba-global-picage-detail-row b.is-free{
        color:#15803d;
      }

      .ba-saving-badge{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        border-radius:999px!important;
        background:#eaf8ef!important;
        color:#15803d!important;
        padding:5px 9px!important;
        font-weight:950!important;
        white-space:nowrap!important;
      }

      .ba-global-total > span{
        max-width:55%;
        line-height:1.2;
      }

      @media(min-width:1000px){
        .ba-global-picage-detail__title{
          font-size:19px!important;
        }

        .ba-global-picage-detail-row span,
        .ba-global-picage-detail-row b{
          font-size:17px!important;
        }

        .ba-saving-badge{
          padding:7px 11px!important;
          font-size:17px!important;
        }

        .ba-global-total > span{
          font-size:18px!important;
        }
      }
    `;
    document.head.appendChild(globalSummaryCleanStyle);


    /* BA PARCHES V3.2 — MODAL DATOS + SOLO ENVIAR */
    var modalCustomerStyle = document.createElement('style');
    modalCustomerStyle.id = 'baPatchesCustomerModalV32';
    modalCustomerStyle.textContent = `
      .ba-order-summary--summary-only{
        display:block!important;
        max-width:520px!important;
        margin-left:auto!important;
      }

      .ba-order-summary--summary-only [data-global-summary]{
        width:100%!important;
      }

      .ba-actions--single{
        display:block!important;
      }

      .ba-actions--single .ba-patches-btn{
        width:100%!important;
        min-height:52px!important;
      }

      body.ba-patches-modal-open{
        overflow:hidden!important;
      }

      .ba-customer-modal{
        position:fixed!important;
        inset:0!important;
        z-index:999999!important;
        display:none!important;
        align-items:center!important;
        justify-content:center!important;
        padding:22px!important;
      }

      .ba-customer-modal.is-open{
        display:flex!important;
      }

      .ba-customer-modal__backdrop{
        position:absolute!important;
        inset:0!important;
        background:rgba(21,16,36,.52)!important;
        backdrop-filter:blur(4px)!important;
      }

      .ba-customer-modal__dialog{
        position:relative!important;
        z-index:1!important;
        width:min(720px,100%)!important;
        max-height:calc(100vh - 44px)!important;
        overflow:auto!important;
        border:1px solid #f0c9d7!important;
        border-radius:24px!important;
        background:#fff!important;
        box-shadow:0 28px 80px rgba(21,16,36,.28)!important;
        padding:24px!important;
      }

      .ba-customer-modal__close{
        position:absolute!important;
        right:15px!important;
        top:15px!important;
        width:38px!important;
        height:38px!important;
        border:0!important;
        border-radius:999px!important;
        background:#fff0f5!important;
        color:#e91458!important;
        font-size:25px!important;
        font-weight:900!important;
        cursor:pointer!important;
      }

      .ba-customer-modal__head{
        display:flex!important;
        align-items:flex-start!important;
        gap:13px!important;
        padding-right:48px!important;
        margin-bottom:20px!important;
      }

      .ba-customer-modal__icon{
        width:44px!important;
        height:44px!important;
        border-radius:13px!important;
        background:#eaf8ef!important;
        color:#15803d!important;
        display:flex!important;
        align-items:center!important;
        justify-content:center!important;
        font-size:22px!important;
        font-weight:950!important;
        flex:0 0 auto!important;
      }

      .ba-customer-modal__head small{
        display:block!important;
        color:#e91458!important;
        font-size:12px!important;
        font-weight:950!important;
        text-transform:uppercase!important;
        letter-spacing:.05em!important;
      }

      .ba-customer-modal__head h2{
        margin:3px 0 4px!important;
        color:#151024!important;
        font-size:28px!important;
        line-height:1.1!important;
        font-weight:950!important;
      }

      .ba-customer-modal__head p{
        margin:0!important;
        color:#756970!important;
        font-size:14px!important;
        line-height:1.45!important;
        font-weight:750!important;
      }

      .ba-customer-modal__grid{
        grid-template-columns:repeat(2,minmax(0,1fr))!important;
        gap:12px!important;
      }

      .ba-customer-modal__note{
        margin-top:15px!important;
        padding:11px 12px!important;
        border-radius:12px!important;
        background:#fff8e8!important;
        color:#71560b!important;
        font-size:12px!important;
        line-height:1.45!important;
        font-weight:850!important;
      }

      .ba-customer-modal__status{
        display:none!important;
        margin-top:12px!important;
        padding:11px 12px!important;
        border-radius:11px!important;
        font-size:12px!important;
        font-weight:850!important;
      }

      .ba-customer-modal__status.is-error{
        display:block!important;
        background:#fff0f4!important;
        color:#a91f4e!important;
      }

      .ba-customer-modal__status.is-ok{
        display:block!important;
        background:#eefbf2!important;
        color:#176a34!important;
      }

      .ba-customer-modal__actions{
        display:flex!important;
        justify-content:flex-end!important;
        gap:10px!important;
        margin-top:18px!important;
      }

      @media(min-width:1000px){
        .ba-order-summary--summary-only{
          max-width:560px!important;
        }

        .ba-actions--single .ba-patches-btn{
          min-height:60px!important;
          font-size:19px!important;
        }

        .ba-customer-modal__dialog{
          width:min(780px,100%)!important;
          padding:28px!important;
        }

        .ba-customer-modal__head h2{
          font-size:34px!important;
        }

        .ba-customer-modal__head p{
          font-size:17px!important;
        }

        .ba-customer-modal__head small{
          font-size:14px!important;
        }

        .ba-customer-modal__note,
        .ba-customer-modal__status{
          font-size:15px!important;
        }
      }

      @media(max-width:720px){
        .ba-order-summary--summary-only{
          max-width:none!important;
          margin-left:0!important;
        }

        .ba-customer-modal{
          padding:10px!important;
          align-items:flex-end!important;
        }

        .ba-customer-modal__dialog{
          width:100%!important;
          max-height:92vh!important;
          border-radius:22px 22px 0 0!important;
          padding:20px 16px!important;
        }

        .ba-customer-modal__grid{
          grid-template-columns:1fr!important;
        }

        .ba-customer-modal__actions{
          flex-direction:column-reverse!important;
        }

        .ba-customer-modal__actions .ba-patches-btn{
          width:100%!important;
        }
      }
    `;

    modalCustomerStyle.textContent += `
      .ba-customer-modal__success{
        text-align:center!important;
        padding:16px 4px 4px!important;
      }

      .ba-customer-modal__success-icon{
        width:72px!important;
        height:72px!important;
        margin:0 auto 16px!important;
        border-radius:999px!important;
        display:flex!important;
        align-items:center!important;
        justify-content:center!important;
        background:#eaf8ef!important;
        color:#15803d!important;
        font-size:38px!important;
        line-height:1!important;
        font-weight:950!important;
      }

      .ba-customer-modal__success h3{
        margin:0!important;
        color:#151024!important;
        font-size:30px!important;
        line-height:1.1!important;
        font-weight:950!important;
      }

      .ba-customer-modal__success p{
        max-width:560px!important;
        margin:10px auto 0!important;
        color:#756970!important;
        font-size:15px!important;
        line-height:1.5!important;
        font-weight:750!important;
      }

      .ba-customer-modal__reference{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        margin-top:16px!important;
        padding:9px 13px!important;
        border-radius:999px!important;
        background:#fff0f5!important;
        color:#e91458!important;
        font-size:13px!important;
        font-weight:950!important;
      }

      .ba-customer-modal__success-note{
        max-width:560px!important;
        margin:15px auto 0!important;
        padding:11px 13px!important;
        border-radius:12px!important;
        background:#fff8e8!important;
        color:#71560b!important;
        font-size:12px!important;
        line-height:1.45!important;
        font-weight:850!important;
        text-align:left!important;
      }

      .ba-customer-modal__success-actions{
        display:flex!important;
        justify-content:center!important;
        margin-top:20px!important;
      }

      .ba-customer-modal__success-actions .ba-patches-btn{
        min-width:180px!important;
      }

      @media(min-width:1000px){
        .ba-customer-modal__success{
          padding:24px 8px 8px!important;
        }

        .ba-customer-modal__success-icon{
          width:82px!important;
          height:82px!important;
          font-size:44px!important;
        }

        .ba-customer-modal__success h3{
          font-size:36px!important;
        }

        .ba-customer-modal__success p{
          font-size:17px!important;
        }

        .ba-customer-modal__reference{
          font-size:15px!important;
          padding:10px 15px!important;
        }

        .ba-customer-modal__success-note{
          font-size:14px!important;
        }
      }
    `;

    document.head.appendChild(modalCustomerStyle);


    /* BA PARCHES V3.3 — RESUMEN FINAL MÁS COMPACTO Y VISUAL */
    var compactSummaryStyle = document.createElement('style');
    compactSummaryStyle.id = 'baPatchesCompactSummaryV33';
    compactSummaryStyle.textContent = `
      .ba-order-summary--summary-only{
        max-width:680px!important;
        margin:22px auto 0!important;
      }

      .ba-global-summary{
        border-radius:22px!important;
        overflow:hidden!important;
      }

      .ba-global-summary__head{
        padding:17px 18px 14px!important;
      }

      .ba-global-summary__head strong{
        font-size:24px!important;
      }

      .ba-global-summary__head small{
        margin-top:5px!important;
        font-size:13px!important;
      }

      .ba-global-summary__body{
        padding:15px 18px 18px!important;
      }

      .ba-global-picage-detail{
        padding-bottom:7px!important;
      }

      .ba-global-picage-detail__title{
        margin-bottom:4px!important;
        font-size:17px!important;
      }

      .ba-global-picage-detail-row{
        padding:4px 0!important;
      }

      .ba-global-picage-detail-row span,
      .ba-global-picage-detail-row b{
        font-size:15px!important;
      }

      .ba-global-line{
        padding:9px 0!important;
      }

      .ba-global-line span{
        font-size:14px!important;
      }

      .ba-saving-badge{
        padding:6px 10px!important;
        font-size:15px!important;
      }

      .ba-global-total{
        margin-top:10px!important;
        padding-top:3px!important;
        align-items:center!important;
      }

      .ba-global-total > span{
        max-width:58%!important;
        font-size:16px!important;
        line-height:1.25!important;
      }

      .ba-global-total-stack s{
        font-size:15px!important;
      }

      .ba-global-total-stack b,
      .ba-global-total-normal{
        font-size:36px!important;
      }

      .ba-review-note{
        margin-top:12px!important;
        padding:10px 12px!important;
        font-size:12px!important;
        line-height:1.45!important;
      }

      .ba-actions--single{
        margin-top:12px!important;
      }

      .ba-actions--single .ba-patches-btn{
        min-height:48px!important;
        padding:12px 18px!important;
        font-size:16px!important;
        border-radius:13px!important;
      }

      .ba-global-summary__head::after{
        content:'';
        display:flex;
      }

      @media(min-width:1000px){
        .ba-order-summary--summary-only{
          max-width:700px!important;
        }
      }

      @media(max-width:720px){
        .ba-order-summary--summary-only{
          max-width:none!important;
          margin:16px 0 0!important;
        }

        .ba-global-total{
          align-items:flex-end!important;
        }

        .ba-global-total > span{
          max-width:52%!important;
        }
      }
    `;
    document.head.appendChild(compactSummaryStyle);


    /* BA PARCHES V3.4 — AÑADIR DISEÑO ARRIBA/ABAJO + SCROLL AL NUEVO */
    var addDesignUxStyle = document.createElement('style');
    addDesignUxStyle.id = 'baPatchesAddDesignUxV34';
    addDesignUxStyle.textContent = `
      .ba-add-design-bottom{
        display:flex!important;
        justify-content:center!important;
        margin:18px 0 4px!important;
      }

      .ba-add-design-bottom .ba-patches-btn{
        min-width:220px!important;
      }

      .ba-patch-v2{
        scroll-margin-top:24px!important;
      }

      .ba-patch-v2--just-added{
        animation:baPatchJustAdded 1.5s ease!important;
      }

      @keyframes baPatchJustAdded{
        0%{
          box-shadow:0 0 0 4px rgba(233,20,88,.22),0 14px 34px rgba(34,17,26,.055);
        }
        100%{
          box-shadow:0 14px 34px rgba(34,17,26,.055);
        }
      }

      @media(min-width:1000px){
        .ba-add-design-bottom{
          margin:22px 0 6px!important;
        }

        .ba-add-design-bottom .ba-patches-btn{
          min-width:260px!important;
          font-size:17px!important;
        }
      }

      @media(max-width:720px){
        .ba-add-design-bottom{
          margin:14px 0 2px!important;
        }

        .ba-add-design-bottom .ba-patches-btn{
          width:100%!important;
          min-width:0!important;
        }

        .ba-patch-v2{
          scroll-margin-top:12px!important;
        }
      }
    `;
    document.head.appendChild(addDesignUxStyle);


    /* BA PARCHES V3.5 — QUITAR LOGO + VALIDACIÓN COMPLETA */
    var validationLogoStyle = document.createElement('style');
    validationLogoStyle.id = 'baPatchesValidationLogoV35';
    validationLogoStyle.textContent = `
      .ba-upload-preview{
        position:relative!important;
      }

      .ba-remove-logo{
        position:absolute!important;
        top:7px!important;
        right:7px!important;
        width:30px!important;
        height:30px!important;
        display:flex!important;
        align-items:center!important;
        justify-content:center!important;
        border:0!important;
        border-radius:999px!important;
        background:#fff!important;
        color:#e91458!important;
        box-shadow:0 3px 12px rgba(21,16,36,.18)!important;
        font-size:21px!important;
        line-height:1!important;
        font-weight:950!important;
        cursor:pointer!important;
        z-index:2!important;
      }

      .ba-remove-logo:hover{
        background:#fff0f5!important;
        transform:scale(1.05)!important;
      }

      .ba-status.is-error{
        display:block!important;
        margin-top:12px!important;
        padding:12px 14px!important;
        border:1px solid #f2b6c9!important;
        border-radius:12px!important;
        background:#fff0f4!important;
        color:#a91f4e!important;
        font-weight:900!important;
        line-height:1.45!important;
      }

      @media(min-width:1000px){
        .ba-remove-logo{
          width:34px!important;
          height:34px!important;
          font-size:24px!important;
        }

        .ba-status.is-error{
          font-size:15px!important;
        }
      }
    `;
    document.head.appendChild(validationLogoStyle);


    /* BA PARCHES V3.6 — CRUZ FUERA DE LA IMAGEN */
    var removeLogoOutsideStyle = document.createElement('style');
    removeLogoOutsideStyle.id = 'baPatchesRemoveLogoOutsideV36';
    removeLogoOutsideStyle.textContent = `
      .ba-upload-preview{
        overflow:visible!important;
      }

      .ba-upload-preview img{
        border-radius:15px!important;
        overflow:hidden!important;
      }

      .ba-remove-logo{
        top:-12px!important;
        right:-12px!important;
      }

      @media(min-width:1000px){
        .ba-remove-logo{
          top:-14px!important;
          right:-14px!important;
        }
      }

      @media(max-width:720px){
        .ba-remove-logo{
          top:-10px!important;
          right:-10px!important;
        }
      }
    `;
    document.head.appendChild(removeLogoOutsideStyle);


    /* BA PARCHES V3.7 — ERRORES GUIADOS */
    var guidedValidationStyle = document.createElement('style');
    guidedValidationStyle.id = 'baPatchesGuidedValidationV37';
    guidedValidationStyle.textContent = `
      .ba-validation-error{
        position:relative!important;
        border-color:#e91458!important;
        box-shadow:0 0 0 3px rgba(233,20,88,.10)!important;
        background:#fff8fb!important;
      }

      .ba-field.ba-validation-error input,
      .ba-field.ba-validation-error textarea{
        border-color:#e91458!important;
        box-shadow:0 0 0 3px rgba(233,20,88,.08)!important;
      }

      .ba-inline-error{
        display:flex!important;
        align-items:center!important;
        gap:6px!important;
        margin-top:8px!important;
        padding:8px 10px!important;
        border-radius:9px!important;
        background:#fff0f4!important;
        color:#b50c43!important;
        font-size:10px!important;
        line-height:1.35!important;
        font-weight:950!important;
      }

      .ba-inline-error::before{
        content:'!';
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        width:18px!important;
        height:18px!important;
        flex:0 0 18px!important;
        border-radius:999px!important;
        background:#e91458!important;
        color:#fff!important;
        font-size:11px!important;
        font-weight:950!important;
      }

      .ba-step-card.ba-validation-error{
        animation:baValidationPulse .65s ease 2!important;
      }

      @keyframes baValidationPulse{
        0%,100%{box-shadow:0 0 0 3px rgba(233,20,88,.10)!important}
        50%{box-shadow:0 0 0 7px rgba(233,20,88,.16)!important}
      }

      @media(min-width:1000px){
        .ba-inline-error{
          margin-top:10px!important;
          padding:10px 12px!important;
          font-size:14px!important;
        }

        .ba-inline-error::before{
          width:22px!important;
          height:22px!important;
          flex-basis:22px!important;
          font-size:13px!important;
        }
      }
    `;
    document.head.appendChild(guidedValidationStyle);


    /* BA PARCHES V3.9 — ACABADO / APLICACIÓN */
    var applicationStyle = document.createElement('style');
    applicationStyle.id = 'baPatchesApplicationV39';
    applicationStyle.textContent = `
      .ba-application-grid{
        display:grid;
        grid-template-columns:repeat(2,minmax(0,1fr));
        gap:10px;
      }

      .ba-application-option{
        display:flex;
        align-items:flex-start;
        gap:11px;
        width:100%;
        min-height:108px;
        border:1px solid var(--ba-line);
        border-radius:14px;
        background:#fff;
        padding:13px;
        text-align:left;
        font:inherit;
        cursor:pointer;
        transition:.15s ease;
      }

      .ba-application-option:hover{
        transform:translateY(-1px);
        border-color:#efbfd0;
      }

      .ba-application-option.is-active{
        border:2px solid var(--ba-pink);
        background:#fff5f8;
        padding:12px;
        box-shadow:0 7px 18px rgba(233,20,88,.10);
      }

      .ba-application-option__icon{
        width:42px;
        height:42px;
        flex:0 0 42px;
        display:flex;
        align-items:center;
        justify-content:center;
        border-radius:12px;
        background:var(--ba-pink-soft);
        font-size:20px;
      }

      .ba-application-option__content{
        display:block;
        min-width:0;
      }

      .ba-application-option__content b{
        display:block;
        color:var(--ba-ink);
        font-weight:950;
        font-size:13px;
      }

      .ba-application-option__content small{
        display:block;
        margin-top:4px;
        color:var(--ba-muted);
        font-size:9px;
        line-height:1.4;
        font-weight:750;
      }

      .ba-application-option__content em{
        display:inline-block;
        margin-top:7px;
        color:var(--ba-pink);
        font-size:9px;
        line-height:1.35;
        font-style:normal;
        font-weight:950;
      }

      @media(min-width:1000px){
        .ba-application-grid{
          gap:13px!important;
        }

        .ba-application-option{
          min-height:145px!important;
          border-radius:18px!important;
          padding:17px!important;
          gap:14px!important;
        }

        .ba-application-option.is-active{
          padding:16px!important;
        }

        .ba-application-option__icon{
          width:52px!important;
          height:52px!important;
          flex-basis:52px!important;
          font-size:25px!important;
        }

        .ba-application-option__content b{
          font-size:21px!important;
        }

        .ba-application-option__content small{
          margin-top:6px!important;
          font-size:17px!important;
          line-height:1.5!important;
        }

        .ba-application-option__content em{
          margin-top:9px!important;
          font-size:16px!important;
        }
      }

      @media(max-width:720px){
        .ba-application-grid{
          grid-template-columns:1fr!important;
        }
      }
    `;
    document.head.appendChild(applicationStyle);


    /* BA PARCHES V4.0 — DESGLOSE DE PARCHES EN RESUMEN GLOBAL */
    var globalPatchBreakdownStyle = document.createElement('style');
    globalPatchBreakdownStyle.id = 'baPatchesGlobalPatchBreakdownV40';
    globalPatchBreakdownStyle.textContent = `
      .ba-global-patches-detail{
        padding-bottom:10px!important;
        margin-bottom:8px!important;
        border-bottom:1px solid #f2e5ea!important;
      }

      .ba-global-patches-detail__title{
        color:#151024!important;
        font-weight:950!important;
        margin-bottom:6px!important;
      }

      .ba-global-patch-row{
        display:grid!important;
        grid-template-columns:minmax(0,1fr) auto!important;
        align-items:center!important;
        gap:12px!important;
        padding:7px 0!important;
      }

      .ba-global-patch-info{
        min-width:0!important;
      }

      .ba-global-patch-info > strong{
        display:block!important;
        color:#151024!important;
        font-weight:950!important;
      }

      .ba-global-patch-info > span{
        display:flex!important;
        align-items:center!important;
        gap:6px!important;
        flex-wrap:wrap!important;
        margin-top:2px!important;
        color:#756970!important;
        font-weight:800!important;
      }

      .ba-global-patch-unit{
        display:inline-flex!important;
        align-items:center!important;
        gap:5px!important;
      }

      .ba-global-patch-unit s,
      .ba-global-patch-total s{
        color:#9a8f95!important;
        font-weight:850!important;
        text-decoration-thickness:2px!important;
      }

      .ba-global-patch-unit b{
        color:#15803d!important;
        font-weight:950!important;
      }

      .ba-global-patch-unit b.is-normal{
        color:#151024!important;
      }

      .ba-global-patch-total{
        display:flex!important;
        flex-direction:column!important;
        align-items:flex-end!important;
        gap:2px!important;
        white-space:nowrap!important;
      }

      .ba-global-patch-total b{
        color:#15803d!important;
        font-weight:950!important;
      }

      .ba-global-patch-total-normal{
        color:#151024!important;
        font-weight:950!important;
        white-space:nowrap!important;
      }

      @media(min-width:1000px){
        .ba-global-patches-detail__title{
          font-size:19px!important;
        }

        .ba-global-patch-info > strong{
          font-size:17px!important;
        }

        .ba-global-patch-info > span{
          font-size:14px!important;
        }

        .ba-global-patch-unit{
          font-size:14px!important;
        }

        .ba-global-patch-total,
        .ba-global-patch-total-normal{
          font-size:17px!important;
        }

        .ba-global-patch-total s{
          font-size:13px!important;
        }
      }

      @media(max-width:720px){
        .ba-global-patch-row{
          align-items:flex-start!important;
        }

        .ba-global-patch-info > span{
          line-height:1.35!important;
        }
      }
    `;
    document.head.appendChild(globalPatchBreakdownStyle);


    /* BA PARCHES V4.1 — PARCHE X EN ROSITA */
    var patchLabelPinkStyle = document.createElement('style');
    patchLabelPinkStyle.id = 'baPatchesPatchLabelPinkV41';
    patchLabelPinkStyle.textContent = `
      .ba-global-patch-info > strong{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        width:max-content!important;
        padding:4px 8px!important;
        border-radius:999px!important;
        background:#fff0f5!important;
        color:#e91458!important;
        font-weight:950!important;
      }

      @media(min-width:1000px){
        .ba-global-patch-info > strong{
          padding:5px 9px!important;
          font-size:16px!important;
        }
      }
    `;
    document.head.appendChild(patchLabelPinkStyle);


    /* BA PARCHES V4.2 — PRECIO/UD Y TOTAL PARCHE AL MISMO NIVEL */
    var estimateLabelsEqualStyle = document.createElement('style');
    estimateLabelsEqualStyle.id = 'baPatchesEstimateLabelsEqualV42';
    estimateLabelsEqualStyle.textContent = `
      .ba-estimate-price__unit > span,
      .ba-estimate-total > span{
        color:#fff!important;
        opacity:1!important;
        font-weight:950!important;
        line-height:1.2!important;
      }

      @media(min-width:1000px){
        .ba-estimate-price__unit > span,
        .ba-estimate-total > span{
          font-size:21px!important;
        }
      }

      @media(max-width:999px){
        .ba-estimate-price__unit > span,
        .ba-estimate-total > span{
          font-size:11px!important;
        }
      }
    `;
    document.head.appendChild(estimateLabelsEqualStyle);

    /* BA PARCHES V4.3 — DIFICULTADES ESTILO BORDADO, AISLADAS */
    var difficultyExamplesStyle = document.createElement('style');
    difficultyExamplesStyle.id = 'baPatchesDifficultyExamplesV43';
    difficultyExamplesStyle.textContent = `
      .ba-patches-v2 .ba-difficulty{
        display:flex!important;
        flex-direction:column!important;
        align-items:stretch!important;
      }

      .ba-patches-v2 .ba-difficulty__top{
        display:flex!important;
        flex-direction:column!important;
        align-items:flex-start!important;
        gap:6px!important;
        padding-right:30px!important;
      }

      .ba-patches-v2 .ba-difficulty__indicator{
        position:absolute!important;
        top:12px!important;
        right:12px!important;
        width:22px!important;
        height:22px!important;
        display:flex!important;
        align-items:center!important;
        justify-content:center!important;
        border:1px solid #dbc7d0!important;
        border-radius:50%!important;
        background:#fff!important;
        color:transparent!important;
        font-size:13px!important;
        font-weight:950!important;
      }

      .ba-patches-v2 .ba-difficulty.is-active .ba-difficulty__indicator{
        border-color:#18823e!important;
        background:#18823e!important;
        color:#fff!important;
      }

      .ba-patches-v2 .ba-step-number{
        background:#171217!important;
        color:#fff!important;
      }

      .ba-patches-v2 .ba-step-number.is-complete{
        background:#e8f7ec!important;
        color:#18823e!important;
        font-weight:950!important;
      }

      .ba-patches-v2 .ba-step-card.is-locked{
        opacity:.46!important;
        filter:grayscale(.8)!important;
        user-select:none!important;
      }

      .ba-patches-v2 .ba-step-card.is-locked button,
      .ba-patches-v2 .ba-step-card.is-locked input,
      .ba-patches-v2 .ba-step-card.is-locked textarea,
      .ba-patches-v2 .ba-step-card.is-locked [role="button"]{
        pointer-events:none!important;
      }

      .ba-patches-v2 .ba-summary-pending{
        display:grid!important;
        gap:13px!important;
        padding:18px!important;
      }

      .ba-patches-v2 .ba-summary-pending__badge{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        width:max-content!important;
        padding:6px 10px!important;
        border-radius:999px!important;
        background:#f0f1f3!important;
        color:#5e636b!important;
        font-size:11px!important;
        font-weight:900!important;
      }

      .ba-patches-v2 .ba-summary-pending__title{
        display:block!important;
        color:#171217!important;
        font-size:15px!important;
        line-height:1.35!important;
        font-weight:950!important;
      }

      .ba-patches-v2 .ba-summary-pending__text{
        margin:0!important;
        color:#756970!important;
        font-size:12px!important;
        line-height:1.55!important;
      }

      .ba-patches-v2 .ba-summary-pending__next{
        padding:11px 12px!important;
        border:1px solid #eadde2!important;
        border-radius:11px!important;
        background:#fffafb!important;
        color:#4a3e45!important;
        font-size:12px!important;
        line-height:1.45!important;
        font-weight:800!important;
      }

      .ba-patches-v2 .ba-summary-pending__patches{
        display:grid!important;
        gap:8px!important;
      }

      .ba-patches-v2 .ba-summary-pending__patch{
        display:flex!important;
        align-items:center!important;
        justify-content:space-between!important;
        gap:10px!important;
        padding:10px 12px!important;
        border:1px solid #eadde2!important;
        border-radius:10px!important;
        color:#171217!important;
        font-size:12px!important;
        font-weight:850!important;
      }

      .ba-patches-v2 .ba-summary-pending__patch.is-complete{
        border-color:#cce7d2!important;
        background:#f2fbf4!important;
        color:#18823e!important;
      }

      .ba-patches-v2 .ba-patches-btn[disabled]{
        opacity:.46!important;
        cursor:not-allowed!important;
        box-shadow:none!important;
      }

      .ba-patches-v2 .ba-global-summary--pending .ba-actions{
        margin-top:0!important;
      }

      .ba-patches-v2 .ba-difficulty__badge{
        display:inline-flex!important;
        align-items:center!important;
        width:max-content!important;
        max-width:100%!important;
        padding:5px 10px!important;
        border-radius:999px!important;
        font-size:11px!important;
        line-height:1.2!important;
        font-weight:950!important;
        white-space:normal!important;
      }

      .ba-patches-v2 .ba-difficulty--green .ba-difficulty__badge{
        background:#e8f7ec!important;
        color:#18823e!important;
      }

      .ba-patches-v2 .ba-difficulty--gold .ba-difficulty__badge{
        background:#fff2df!important;
        color:#b76800!important;
      }

      .ba-patches-v2 .ba-difficulty--pink .ba-difficulty__badge{
        background:#fdebed!important;
        color:#c72b39!important;
      }

      .ba-patches-v2 .ba-difficulty__name{
        color:#171217!important;
        line-height:1.2!important;
      }

      .ba-patches-v2 .ba-difficulty__examples-list{
        display:grid!important;
        gap:5px!important;
        margin:9px 0 0!important;
        padding:0!important;
        list-style:none!important;
      }

      .ba-patches-v2 .ba-difficulty__example-item{
        display:flex!important;
        align-items:flex-start!important;
        gap:7px!important;
        color:#30272d!important;
        font-size:10px!important;
        line-height:1.35!important;
        font-weight:800!important;
      }

      .ba-patches-v2 .ba-difficulty__example-item::before{
        content:''!important;
        width:6px!important;
        height:6px!important;
        margin-top:4px!important;
        border-radius:50%!important;
        background:#f3a4bd!important;
        flex:0 0 auto!important;
      }

      .ba-patches-v2 .ba-difficulty__examples-link{
        display:inline-flex!important;
        align-self:flex-start!important;
        width:max-content!important;
        margin-top:9px!important;
        color:#1f71dd!important;
        font-size:11px!important;
        line-height:1.3!important;
        font-weight:950!important;
        text-decoration:underline!important;
        cursor:pointer!important;
      }

      .ba-patches-v2 .ba-difficulty__choose{
        display:flex!important;
        margin-top:auto!important;
        padding-top:11px!important;
        border-top:1px dashed #ecd6df!important;
      }

      .ba-patches-v2 .ba-difficulty__examples-link + .ba-difficulty__choose{
        margin-top:12px!important;
      }

      .ba-patches-difficulty-modal{
        position:fixed!important;
        inset:0!important;
        z-index:1000000!important;
        display:flex!important;
        align-items:center!important;
        justify-content:center!important;
        padding:24px!important;
        background:rgba(23,18,23,.56)!important;
      }

      .ba-patches-difficulty-modal__dialog{
        position:relative!important;
        width:min(1180px,96vw)!important;
        max-height:92vh!important;
        overflow:auto!important;
        padding:34px!important;
        border-radius:24px!important;
        background:#fff!important;
        box-shadow:0 22px 70px rgba(23,18,23,.24)!important;
        color:#171217!important;
      }

      .ba-patches-difficulty-modal__close{
        position:absolute!important;
        top:12px!important;
        right:12px!important;
        width:34px!important;
        height:34px!important;
        border:0!important;
        border-radius:50%!important;
        background:#f6f1f3!important;
        color:#171217!important;
        font-size:23px!important;
        line-height:1!important;
        cursor:pointer!important;
      }

      .ba-patches-difficulty-modal__title{
        margin:0 36px 6px 0!important;
        font-size:30px!important;
        line-height:1.25!important;
        font-weight:950!important;
      }

      .ba-patches-difficulty-modal__description{
        margin:0!important;
        color:#756970!important;
        font-size:17px!important;
        line-height:1.55!important;
      }

      .ba-patches-difficulty-modal__grid{
        display:grid!important;
        grid-template-columns:repeat(3,minmax(0,1fr))!important;
        gap:20px!important;
        margin-top:26px!important;
      }

      .ba-patches-difficulty-modal__example{
        min-width:0!important;
      }

      .ba-patches-difficulty-modal__example-label{
        display:block!important;
        margin:0 0 9px!important;
        color:#171217!important;
        font-size:18px!important;
        line-height:1.25!important;
        font-weight:950!important;
      }

      .ba-patches-difficulty-modal__image{
        display:block!important;
        width:100%!important;
        aspect-ratio:1!important;
        object-fit:contain!important;
        border:1px solid #ecdfe4!important;
        border-radius:18px!important;
        background:#fff!important;
      }

      .ba-patches-difficulty-modal__list{
        display:grid!important;
        gap:10px!important;
        margin:19px 0 0!important;
        padding-left:19px!important;
        font-size:16px!important;
        line-height:1.5!important;
        font-weight:750!important;
      }

      .ba-patches-difficulty-modal__list li::marker{
        color:#e91458!important;
      }

      @media(min-width:1000px){
        .ba-patches-v2 .ba-difficulty__badge{
          padding:6px 12px!important;
          font-size:14px!important;
        }

        .ba-patches-v2 .ba-difficulty__example-item{
          font-size:13px!important;
        }

        .ba-patches-v2 .ba-difficulty__examples-link{
          font-size:14px!important;
        }
      }

      @media(max-width:640px){
        .ba-patches-difficulty-modal{
          padding:10px!important;
        }

        .ba-patches-difficulty-modal__dialog{
          width:100%!important;
          max-height:94vh!important;
          padding:24px 17px!important;
        }

        .ba-patches-difficulty-modal__grid{
          grid-template-columns:1fr!important;
          gap:20px!important;
        }

        .ba-patches-difficulty-modal__title{
          font-size:24px!important;
        }

        .ba-patches-difficulty-modal__description{
          font-size:15px!important;
        }

        .ba-patches-difficulty-modal__example-label{
          font-size:17px!important;
        }
      }
    `;
    document.head.appendChild(difficultyExamplesStyle);

  /* ============================================================
     HTML
     ============================================================ */

  function difficultyCardsHtml(patch) {
    return CONFIG.DIFFICULTY_TIERS.map(function (tier) {
      var active = patch.difficulty === tier.key;
      var visibleExamples = (tier.examples || []).slice(0, 2).map(function (example) {
        return '<span class="ba-difficulty__example-item">' + esc(example) + '</span>';
      }).join('');

      return '' +
        '<button type="button" ' +
          'class="ba-difficulty ba-difficulty--' + esc(tier.tone) +
          (active ? ' is-active' : '') + '" ' +
          'data-difficulty="' + esc(tier.key) + '">' +
          '<span class="ba-difficulty__indicator" aria-hidden="true">' +
            (active ? '✓' : '') +
          '</span>' +
          '<span class="ba-difficulty__top">' +
            '<span class="ba-difficulty__badge">' + esc(tier.label) + '</span>' +
            '<b class="ba-difficulty__name">' + esc(tier.shortLabel) + '</b>' +
          '</span>' +
          '<p>' + esc(tier.description) + '</p>' +
          '<span class="ba-difficulty__examples-list">' + visibleExamples + '</span>' +
          '<span class="ba-difficulty__examples-link" role="button" tabindex="0" ' +
            'data-difficulty-examples="' + esc(tier.key) + '">Ver ejemplos</span>' +
          '<span class="ba-difficulty__choose">' +
            (active ? '✓ Seleccionado' : 'Seleccionar') +
          '</span>' +
        '</button>';
    }).join('');
  }

  function openDifficultyExamples(tierKey) {
    var tier = getDifficulty(tierKey);
    if (!tier) return;

    var previous = document.querySelector('.ba-patches-difficulty-modal');
    if (previous) previous.remove();

    var configuredImages = Array.isArray(tier.exampleImages)
      ? tier.exampleImages.filter(function (url) { return !!String(url || '').trim(); })
      : [];

    var imagesHtml = configuredImages.length
      ? '<div class="ba-patches-difficulty-modal__grid">' +
          configuredImages.map(function (url, index) {
            return '<div class="ba-patches-difficulty-modal__example">' +
              '<strong class="ba-patches-difficulty-modal__example-label">Ejemplo ' + (index + 1) + '</strong>' +
              '<img class="ba-patches-difficulty-modal__image" src="' + esc(url) + '" ' +
                'alt="Ejemplo ' + esc(tier.shortLabel) + ' ' + (index + 1) + '" loading="lazy">' +
            '</div>';
          }).join('') +
        '</div>'
      : '';

    var examplesHtml = (tier.examples || []).map(function (example) {
      return '<li>' + esc(example) + '</li>';
    }).join('');

    var modal = document.createElement('div');
    modal.className = 'ba-patches-difficulty-modal';
    modal.innerHTML =
      '<div class="ba-patches-difficulty-modal__dialog" role="dialog" aria-modal="true" ' +
        'aria-labelledby="baPatchesDifficultyExamplesTitle">' +
        '<button type="button" class="ba-patches-difficulty-modal__close" ' +
          'data-close-difficulty-examples aria-label="Cerrar">×</button>' +
        '<h2 class="ba-patches-difficulty-modal__title" id="baPatchesDifficultyExamplesTitle">' +
          'Ejemplos · ' + esc(tier.label) +
        '</h2>' +
        '<p class="ba-patches-difficulty-modal__description">' + esc(tier.description) + '</p>' +
        imagesHtml +
        '<ul class="ba-patches-difficulty-modal__list">' + examplesHtml + '</ul>' +
      '</div>';

    function closeExamples() {
      document.removeEventListener('keydown', onEscape);
      modal.remove();
    }

    function onEscape(event) {
      if (event.key === 'Escape') closeExamples();
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-close-difficulty-examples]')) {
        closeExamples();
      }
    });

    document.addEventListener('keydown', onEscape);
    document.body.appendChild(modal);

    var closeButton = modal.querySelector('[data-close-difficulty-examples]');
    if (closeButton) closeButton.focus();
  }

  function colorCardsHtml(patch) {
    return CONFIG.COLOR_OPTIONS.map(function (option) {
      var active = patch.colors === option.key;

      return '' +
        '<button type="button" class="ba-color-option' +
          (active ? ' is-active' : '') + '" ' +
          'data-colors="' + esc(option.key) + '">' +
          '<b>' + esc(option.label) + '</b>' +
          '<span>' + esc(option.help) + '</span>' +
        '</button>';
    }).join('');
  }

  function shapeCardsHtml(patch) {
    return CONFIG.SHAPES.map(function (shape) {
      var active = patch.shape === shape.key;

      return '' +
        '<button type="button" class="ba-shape' +
          (active ? ' is-active' : '') + '" ' +
          'data-shape="' + esc(shape.key) + '">' +
          shapeSvg(shape.icon) +
          '<span>' + esc(shape.label) + '</span>' +
        '</button>';
    }).join('');
  }

  function applicationCardsHtml(patch) {
    return CONFIG.APPLICATION_OPTIONS.map(function (option) {
      var active = patch.application === option.key;
      var extra = option.key === 'termoadhesivo'
        ? '5–8 cm: +0,20 €/ud · >8–12 cm: +0,30 €/ud'
        : 'Sin coste adicional';

      return '' +
        '<button type="button" class="ba-application-option' +
          (active ? ' is-active' : '') + '" ' +
          'data-application="' + esc(option.key) + '">' +
          '<span class="ba-application-option__icon">' + esc(option.icon) + '</span>' +
          '<span class="ba-application-option__content">' +
            '<b>' + esc(option.label) + '</b>' +
            '<small>' + esc(option.description) + '</small>' +
            '<em>' + esc(extra) + '</em>' +
          '</span>' +
        '</button>';
    }).join('');
  }

  function getPatchPendingSteps(patch) {
    var pending = [];

    if (!patch.logoUrl || Number(patch.quantity) < CONFIG.MIN_QUANTITY) {
      pending.push('Sube tu diseño y elige la cantidad');
    }

    if (!patch.difficulty) pending.push('Selecciona la dificultad');
    if (!patch.colors) pending.push('Selecciona el número de colores');

    if (!patch.shape ||
      Number(patch.widthCm) < CONFIG.MIN_SIZE_CM || Number(patch.widthCm) > CONFIG.MAX_SIZE_CM ||
      Number(patch.heightCm) < CONFIG.MIN_SIZE_CM || Number(patch.heightCm) > CONFIG.MAX_SIZE_CM) {
      pending.push('Elige la forma y comprueba las medidas');
    }

    if (!patch.application) pending.push('Selecciona cómo aplicar el parche');

    return pending;
  }

  function isPatchComplete(patch) {
    return getPatchPendingSteps(patch).length === 0;
  }

  function estimateHtml(patch) {
    var pendingSteps = getPatchPendingSteps(patch);

    if (pendingSteps.length) {
      return '' +
        '<div class="ba-estimate ba-estimate--pending">' +
          '<div class="ba-estimate__head">' +
            '<small>Estimación automática</small>' +
            '<strong>Resumen de este parche</strong>' +
          '</div>' +
          '<div class="ba-summary-pending">' +
            '<span class="ba-summary-pending__badge">' +
              (5 - pendingSteps.length) + ' de 5 pasos completados' +
            '</span>' +
            '<strong class="ba-summary-pending__title">Estimación todavía no disponible</strong>' +
            '<p class="ba-summary-pending__text">' +
              'Completa los cinco pasos de este parche para activar su estimación automática.' +
            '</p>' +
            '<div class="ba-summary-pending__next">Siguiente paso: ' + esc(pendingSteps[0]) + '</div>' +
          '</div>' +
        '</div>';
    }

    var calc = calculatePatch(patch);
    var next = getNextDiscountHint(calc.quantity);
    var missingPicage = Math.max(0, CONFIG.PICAGE_FREE_FROM - calc.quantity);

    var discountPercentHtml = calc.discountPercent
      ? '<span class="ba-discount-percent-badge">-' + calc.discountPercent + '%</span>'
      : '<b class="ba-discount-zero">0%</b>';

    var discountHintHtml = next
      ? '<span class="ba-discount-hint-badge">↗ Añade ' +
          next.missing + ' uds más y tendrás -' +
          next.discount + '%</span>'
      : '<span class="ba-discount-hint-badge is-max">✓ Máximo descuento</span>';

    var unitPriceHtml = calc.discountPercent
      ? '<div class="ba-price-current is-discounted">' + euro(calc.unitPrice) + '</div>' +
        '<div class="ba-price-before">' + euro(calc.originalUnitPrice) + ' / ud</div>'
      : '<div class="ba-price-current">' + euro(calc.unitPrice) + '</div>';

    var totalHtml = calc.discountPercent
      ? '<div class="ba-total-current is-discounted">' + euro(calc.total) + '</div>' +
        '<div class="ba-total-before">' + euro(calc.totalBeforeDiscount) + '</div>'
      : '<div class="ba-total-current">' + euro(calc.total) + '</div>';

    var picageInfoHtml = calc.picageFree
      ? '<span class="ba-picage-hint-badge is-free">✓ Picaje gratis</span>'
      : '<span class="ba-picage-hint-badge">Faltan ' + missingPicage + ' parches para GRATIS</span>';

    var picageValueHtml = calc.picageFree
      ? '<span class="ba-picage-simple"><s>20,00 €</s><b>GRATIS</b></span>'
      : '<b class="ba-picage-paid">20,00 €</b>';

    return '' +
      '<div class="ba-estimate">' +
        '<div class="ba-estimate__head">' +
          '<small>Estimación automática</small>' +
          '<strong>Resumen de este parche</strong>' +
        '</div>' +

        '<div class="ba-estimate__body">' +
          '<div class="ba-estimate-row">' +
            '<span>Dificultad</span>' +
            '<b>' + esc(calc.difficulty ? calc.difficulty.shortLabel : 'Sin seleccionar') + '</b>' +
          '</div>' +

          '<div class="ba-estimate-row">' +
            '<span>Colores</span>' +
            '<b>' + esc(calc.colors ? calc.colors.label : 'Sin seleccionar') + '</b>' +
          '</div>' +

          '<div class="ba-estimate-row">' +
            '<span>Forma</span>' +
            '<b>' + esc(getShape(patch.shape) ? getShape(patch.shape).label : 'Sin seleccionar') + '</b>' +
          '</div>' +

          '<div class="ba-estimate-row">' +
            '<span>Tamaño</span>' +
            '<b>' +
              esc(Number(patch.widthCm || 0)) + ' × ' +
              esc(Number(patch.heightCm || 0)) + ' cm' +
            '</b>' +
          '</div>' +

          '<div class="ba-estimate-row">' +
            '<span>Acabado</span>' +
            '<b>' + esc(getApplicationLabel(patch)) + '</b>' +
          '</div>' +

          '<div class="ba-estimate-row ba-estimate-row--discount">' +
            '<span class="ba-summary-label-strong">Descuento</span>' +
            '<span class="ba-summary-inline-group">' +
              discountHintHtml +
              discountPercentHtml +
            '</span>' +
          '</div>' +

          '<div class="ba-estimate-row">' +
            '<span class="ba-summary-label-strong">Picaje</span>' +
            '<span class="ba-summary-inline-group">' +
              picageInfoHtml +
              picageValueHtml +
            '</span>' +
          '</div>' +

          '<div class="ba-estimate-price">' +
            '<div class="ba-estimate-price__unit">' +
              '<span>Precio estimado / ud</span>' +
              '<div class="ba-price-stack">' + unitPriceHtml + '</div>' +
            '</div>' +

            '<div class="ba-estimate-total">' +
              '<span>Total parche · ' + calc.quantity + ' uds</span>' +
              '<div class="ba-total-stack">' + totalHtml + '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function stepNumberHtml(number, completed) {
    return '<span class="ba-step-number' + (completed ? ' is-complete' : '') + '" ' +
      'aria-label="Paso ' + number + (completed ? ' completado' : ' pendiente') + '">' +
      (completed ? '✓' : number) +
    '</span>';
  }

  function stepSectionOpenHtml(stepKey, unlocked) {
    return '<section class="ba-step-card' + (unlocked ? '' : ' is-locked') + '" ' +
      'data-step="' + esc(stepKey) + '" aria-disabled="' + (unlocked ? 'false' : 'true') + '"' +
      (unlocked ? '' : ' inert') + '>';
  }

  function patchHtml(patch, index, totalPatches) {
    var uploadDone = !!patch.logoUrl && Number(patch.quantity) >= CONFIG.MIN_QUANTITY;
    var difficultyDone = uploadDone && !!patch.difficulty;
    var colorsDone = difficultyDone && !!patch.colors;
    var shapeDone = colorsDone && !!patch.shape &&
      Number(patch.widthCm) >= CONFIG.MIN_SIZE_CM && Number(patch.widthCm) <= CONFIG.MAX_SIZE_CM &&
      Number(patch.heightCm) >= CONFIG.MIN_SIZE_CM && Number(patch.heightCm) <= CONFIG.MAX_SIZE_CM;
    var applicationDone = shapeDone && !!patch.application;

    return '' +
      '<article class="ba-patch-v2" data-patch-id="' + esc(patch.id) + '">' +
        '<div class="ba-patch-v2__head">' +
          '<div class="ba-patch-v2__title">' +
            '<span class="ba-patch-v2__number">' + (index + 1) + '</span>' +
            '<span>' +
              '<strong>Parche ' + (index + 1) + '</strong>' +
              '<small>Configura este diseño paso a paso</small>' +
            '</span>' +
          '</div>' +

          (totalPatches > 1
            ? '<button type="button" class="ba-patch-remove" data-remove>Eliminar parche</button>'
            : '') +
        '</div>' +

        '<div class="ba-patch-v2__body">' +
          '<div class="ba-patch-config">' +

            stepSectionOpenHtml('upload', true) +
              '<div class="ba-step-head">' +
                '<div class="ba-step-head__left">' +
                  stepNumberHtml(1, uploadDone) +
                  '<div>' +
                    '<strong>Sube tu diseño</strong>' +
                    '<p>Usaremos exactamente este archivo como referencia para revisar el presupuesto.</p>' +
                  '</div>' +
                '</div>' +
              '</div>' +

              '<div class="ba-upload-wrap">' +
                '<div class="ba-upload-preview">' +
                  (patch.logoUrl
                    ? '<img src="' + esc(patch.logoUrl) + '" alt="Diseño del parche">' +
                      '<button type="button" class="ba-remove-logo" data-remove-logo aria-label="Quitar diseño">×</button>'
                    : '<div class="ba-upload-preview__empty"><strong>＋</strong><span>Sube tu logo</span></div>') +
                '</div>' +

                '<div class="ba-upload-control">' +
                  '<input type="file" accept=".png,.jpg,.jpeg,.webp,.pdf,.svg" data-file>' +
                  '<small data-upload-name>' +
                    esc(
                      patch.logoName ||
                      'PNG, JPG, WEBP, PDF o SVG · máximo 5 MB'
                    ) +
                  '</small>' +
                '</div>' +
              '</div>' +

              '<div class="ba-qty-card">' +
                '<div>' +
                  '<strong>¿Cuántos parches necesitas?</strong>' +
                  '<small>El descuento y el picaje se recalculan automáticamente.</small>' +
                '</div>' +

                '<div class="ba-qty-side">' +
                  (getNextDiscountHint(patch.quantity)
                    ? '<span class="ba-qty-discount-hint">Añade ' +
                        getNextDiscountHint(patch.quantity).missing +
                        ' y se aplica ' +
                        getNextDiscountHint(patch.quantity).discount +
                        '% descuento</span>'
                    : '<span class="ba-qty-discount-hint is-max">✓ Máximo descuento aplicado</span>') +
                  '<div class="ba-qty-control">' +
                    '<button type="button" data-qty-minus>−</button>' +
                    '<input type="number" inputmode="numeric" min="1" step="1" value="' +
                      esc(patch.quantity) + '" data-key="quantity">' +
                    '<button type="button" data-qty-plus>+</button>' +
                  '</div>' +
                '</div>' +
              '</div>' +

              '<div class="ba-field" style="margin-top:11px">' +
                '<label>Observaciones para este parche (opcional)</label>' +
                '<textarea data-key="notes" placeholder="Ej.: necesito borde merrow, mantener esta proporción, texto especialmente legible...">' +
                  esc(patch.notes || '') +
                '</textarea>' +
              '</div>' +
            '</section>' +

            stepSectionOpenHtml('difficulty', uploadDone) +
              '<div class="ba-step-head">' +
                '<div class="ba-step-head__left">' +
                  stepNumberHtml(2, difficultyDone) +
                  '<div>' +
                    '<strong>Dificultad del diseño</strong>' +
                    '<p>Como en Bordado: selecciona el nivel que más se parece a tu logo. Nosotros lo revisaremos.</p>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<div class="ba-difficulty-grid">' +
                difficultyCardsHtml(patch) +
              '</div>' +
            '</section>' +

            stepSectionOpenHtml('colors', difficultyDone) +
              '<div class="ba-step-head">' +
                '<div class="ba-step-head__left">' +
                  stepNumberHtml(3, colorsDone) +
                  '<div>' +
                    '<strong>Número de colores</strong>' +
                    '<p>Selecciona aproximadamente cuántos colores tiene el diseño.</p>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<div class="ba-colors-grid">' +
                colorCardsHtml(patch) +
              '</div>' +
            '</section>' +

            stepSectionOpenHtml('shape', colorsDone) +
              '<div class="ba-step-head">' +
                '<div class="ba-step-head__left">' +
                  stepNumberHtml(4, shapeDone) +
                  '<div>' +
                    '<strong>Tamaño y forma</strong>' +
                    '<p>Indica la forma aproximada y las medidas finales que quieres para el parche.</p>' +
                  '</div>' +
                '</div>' +
              '</div>' +

              '<div class="ba-shapes-grid">' +
                shapeCardsHtml(patch) +
              '</div>' +

              '<div class="ba-size-grid">' +
                '<div class="ba-field">' +
                  '<label>Ancho final (cm)</label>' +
                  '<input type="number" step="0.1" min="' +
                    CONFIG.MIN_SIZE_CM + '" max="' +
                    CONFIG.MAX_SIZE_CM + '" value="' +
                    esc(patch.widthCm) + '" data-key="widthCm">' +
                '</div>' +

                '<div class="ba-field">' +
                  '<label>Alto final (cm)</label>' +
                  '<input type="number" step="0.1" min="' +
                    CONFIG.MIN_SIZE_CM + '" max="' +
                    CONFIG.MAX_SIZE_CM + '" value="' +
                    esc(patch.heightCm) + '" data-key="heightCm">' +
                '</div>' +
              '</div>' +

              '<div class="ba-size-note">' +
                '<span>5–8 cm sin coste adicional · >8–12 cm +1 €/ud</span>' +
                '<b data-size-label>' + esc(getSizeLabel(patch)) + '</b>' +
              '</div>' +
            '</section>' +

            stepSectionOpenHtml('application', shapeDone) +
              '<div class="ba-step-head">' +
                '<div class="ba-step-head__left">' +
                  stepNumberHtml(5, applicationDone) +
                  '<div>' +
                    '<strong>¿Cómo quieres aplicar el parche?</strong>' +
                    '<p>Elige si lo coserás tú o si quieres base termoadhesiva para aplicar con calor.</p>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<div class="ba-application-grid">' +
                applicationCardsHtml(patch) +
              '</div>' +
            '</section>' +

          '</div>' +

          '<aside class="ba-patch-summary" data-estimate>' +
            estimateHtml(patch) +
          '</aside>' +
        '</div>' +
      '</article>';
  }

  function customerField(label, name, value, type) {
    return '' +
      '<div class="ba-field">' +
        '<label>' + esc(label) + '</label>' +
        '<input type="' + esc(type || 'text') + '" name="' +
          esc(name) + '" value="' + esc(value || '') + '">' +
      '</div>';
  }

  function globalSummaryHtml(state) {
    var pendingPatches = state.patches.filter(function (patch) {
      return !isPatchComplete(patch);
    });

    if (pendingPatches.length) {
      var patchStatusHtml = state.patches.map(function (patch, index) {
        var pending = getPatchPendingSteps(patch);
        var complete = pending.length === 0;

        return '<div class="ba-summary-pending__patch' + (complete ? ' is-complete' : '') + '">' +
          '<span>Parche ' + (index + 1) + '</span>' +
          '<strong>' + (complete ? '✓ Completado' : (5 - pending.length) + ' de 5 pasos') + '</strong>' +
        '</div>';
      }).join('');

      return '' +
        '<div class="ba-global-summary ba-global-summary--pending">' +
          '<div class="ba-global-summary__head">' +
            '<strong>Resumen del presupuesto</strong>' +
            '<small>' + state.patches.length + ' ' +
              (state.patches.length === 1 ? 'diseño' : 'diseños') + ' · Pendiente de completar' +
            '</small>' +
          '</div>' +
          '<div class="ba-summary-pending">' +
            '<strong class="ba-summary-pending__title">Presupuesto todavía no disponible</strong>' +
            '<p class="ba-summary-pending__text">' +
              'Completa los cinco pasos de todos los parches para activar el resumen del presupuesto.' +
            '</p>' +
            '<div class="ba-summary-pending__patches">' + patchStatusHtml + '</div>' +
            '<div class="ba-actions ba-actions--single">' +
              '<button type="button" class="ba-patches-btn ba-patches-btn--primary" ' +
                'data-send disabled aria-disabled="true">Completa todos los parches para continuar</button>' +
            '</div>' +
            '<div class="ba-status" data-status></div>' +
          '</div>' +
        '</div>';
    }

    var order = calculateOrder(state);
    var hasDiscount = order.discountTotal > 0;

    var patchRowsHtml = state.patches.map(function (patch, index) {
      var calc = calculatePatch(patch);

      var unitPriceHtml = calc.discountPercent
        ? '<span class="ba-global-patch-unit">' +
            '<s>' + euro(calc.originalUnitPrice) + '/ud</s>' +
            '<b>' + euro(calc.unitPrice) + '/ud</b>' +
          '</span>'
        : '<span class="ba-global-patch-unit">' +
            '<b class="is-normal">' + euro(calc.unitPrice) + '/ud</b>' +
          '</span>';

      var lineTotalHtml = calc.discountPercent
        ? '<span class="ba-global-patch-total">' +
            '<s>' + euro(calc.originalUnitPrice * calc.quantity) + '</s>' +
            '<b>' + euro(calc.embroideryTotal) + '</b>' +
          '</span>'
        : '<b class="ba-global-patch-total-normal">' +
            euro(calc.embroideryTotal) +
          '</b>';

      return '' +
        '<div class="ba-global-patch-row">' +
          '<div class="ba-global-patch-info">' +
            '<strong>Parche ' + (index + 1) + '</strong>' +
            '<span>' + calc.quantity + ' uds · ' + unitPriceHtml + '</span>' +
          '</div>' +
          lineTotalHtml +
        '</div>';
    }).join('');

    var picageRowsHtml = state.patches.map(function (patch, index) {
      var calc = calculatePatch(patch);

      return '' +
        '<div class="ba-global-picage-detail-row">' +
          '<span>Parche ' + (index + 1) + '</span>' +
          (calc.picageFree
            ? '<b class="is-free">GRATIS</b>'
            : '<b>' + euro(calc.picage) + '</b>') +
        '</div>';
    }).join('');

    var totalPriceHtml = hasDiscount
      ? '<span class="ba-global-total-stack">' +
          '<s>' + euro(order.totalBeforeDiscount) + '</s>' +
          '<b>' + euro(order.total) + '</b>' +
        '</span>'
      : '<b class="ba-global-total-normal">' + euro(order.total) + '</b>';

    return '' +
      '<div class="ba-global-summary">' +
        '<div class="ba-global-summary__head">' +
          '<strong>Resumen del presupuesto</strong>' +
          '<small>' +
            state.patches.length + ' ' +
            (state.patches.length === 1 ? 'diseño' : 'diseños') +
            ' · ' + order.units + ' uds totales' +
          '</small>' +
        '</div>' +

        '<div class="ba-global-summary__body">' +

          '<div class="ba-global-patches-detail">' +
            '<div class="ba-global-patches-detail__title">Parches</div>' +
            patchRowsHtml +
          '</div>' +

          '<div class="ba-global-picage-detail">' +
            '<div class="ba-global-picage-detail__title">Picajes</div>' +
            picageRowsHtml +
          '</div>' +

          (hasDiscount
            ? '<div class="ba-global-line ba-global-line--saving">' +
                '<span>Ahorro por cantidad</span>' +
                '<b class="ba-saving-badge">-' + euro(order.discountTotal) + '</b>' +
              '</div>'
            : '') +

          '<div class="ba-global-total">' +
            '<span>Total estimado de parches bordados</span>' +
            totalPriceHtml +
          '</div>' +

          '<div class="ba-review-note">' +
            'Precio estimado. Antes de pagar, Bordados Alicante revisará ' +
            'el diseño, dificultad, colores, medidas y viabilidad. ' +
            'Si hay algún ajuste, lo verás claramente antes de aceptar el presupuesto.' +
          '</div>' +

          '<div class="ba-actions ba-actions--single">' +
            '<button type="button" class="ba-patches-btn ba-patches-btn--primary" data-send>' +
              'Enviar para revisión' +
            '</button>' +
          '</div>' +

          '<div class="ba-status" data-status></div>' +
        '</div>' +
      '</div>';
  }

  /* ============================================================
     MONTAJE
     ============================================================ */

  function mount(root) {
    injectStyles();

    var state = readState();

    function captureCustomer(scope) {
      var rootScope = scope || document;

      function valueOf(name) {
        var input = rootScope.querySelector('[name="' + name + '"]');
        return input ? input.value.trim() : '';
      }

      state.customer = {
        name: valueOf('customerName'),
        lastName: valueOf('customerLastName'),
        email: valueOf('customerEmail'),
        phone: valueOf('customerPhone'),
        company: valueOf('customerCompany')
      };

      saveState(state);
    }

    function showStatus(app, message, ok) {
      var status = app.querySelector('[data-status]');
      if (!status) return;

      status.className =
        'ba-status ' + (ok ? 'is-ok' : 'is-error');

      status.textContent = message;
    }

    function clearValidationErrors(scope) {
      (scope || document).querySelectorAll('.ba-validation-error').forEach(function (node) {
        node.classList.remove('ba-validation-error');
      });

      (scope || document).querySelectorAll('.ba-inline-error').forEach(function (node) {
        node.remove();
      });
    }

    function addInlineError(target, message) {
      if (!target) return;

      target.classList.add('ba-validation-error');

      var old = target.querySelector(':scope > .ba-inline-error');
      if (old) old.remove();

      var error = document.createElement('div');
      error.className = 'ba-inline-error';
      error.textContent = message;
      target.appendChild(error);
    }

    function scrollToValidationError(target) {
      if (!target) return;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      setTimeout(function () {
        var focusable = target.querySelector('input, textarea, select, button');
        if (focusable && typeof focusable.focus === 'function') {
          try { focusable.focus({ preventScroll: true }); }
          catch (_) { focusable.focus(); }
        }
      }, 450);
    }

    function validatePatches(app) {
      clearValidationErrors(app);

      if (!state.patches.length) {
        throw new Error('Añade al menos un parche.');
      }

      var firstErrorTarget = null;
      var errorMessages = [];

      state.patches.forEach(function (patch, index) {
        var card = app.querySelector('[data-patch-id="' + patch.id + '"]');
        if (!card) return;

        var prefix = 'Parche ' + (index + 1);

        if (!patch.logoUrl) {
          var uploadStep = card.querySelector('[data-step="upload"]');
          addInlineError(uploadStep, 'Falta subir el diseño/logo.');
          if (!firstErrorTarget) firstErrorTarget = uploadStep;
          errorMessages.push(prefix + ': falta el diseño/logo');
        }

        if (
          !Number(patch.widthCm) ||
          Number(patch.widthCm) < CONFIG.MIN_SIZE_CM ||
          Number(patch.widthCm) > CONFIG.MAX_SIZE_CM
        ) {
          var widthInput = card.querySelector('[data-key="widthCm"]');
          var widthField = widthInput && widthInput.closest('.ba-field');
          addInlineError(
            widthField,
            'Indica un ancho entre ' + CONFIG.MIN_SIZE_CM + ' y ' + CONFIG.MAX_SIZE_CM + ' cm.'
          );
          if (!firstErrorTarget) firstErrorTarget = widthField;
          errorMessages.push(prefix + ': ancho no válido');
        }

        if (
          !Number(patch.heightCm) ||
          Number(patch.heightCm) < CONFIG.MIN_SIZE_CM ||
          Number(patch.heightCm) > CONFIG.MAX_SIZE_CM
        ) {
          var heightInput = card.querySelector('[data-key="heightCm"]');
          var heightField = heightInput && heightInput.closest('.ba-field');
          addInlineError(
            heightField,
            'Indica un alto entre ' + CONFIG.MIN_SIZE_CM + ' y ' + CONFIG.MAX_SIZE_CM + ' cm.'
          );
          if (!firstErrorTarget) firstErrorTarget = heightField;
          errorMessages.push(prefix + ': alto no válido');
        }

        if (
          !Number(patch.quantity) ||
          Number(patch.quantity) < CONFIG.MIN_QUANTITY
        ) {
          var qty = card.querySelector('[data-key="quantity"]');
          var qtyCard = qty && qty.closest('.ba-qty-card');
          addInlineError(qtyCard, 'Indica cuántos parches necesitas.');
          if (!firstErrorTarget) firstErrorTarget = qtyCard;
          errorMessages.push(prefix + ': falta la cantidad');
        }

        if (!patch.difficulty) {
          var difficultyStep = card.querySelector('[data-step="difficulty"]');
          addInlineError(difficultyStep, 'Selecciona la dificultad del diseño.');
          if (!firstErrorTarget) firstErrorTarget = difficultyStep;
          errorMessages.push(prefix + ': falta la dificultad');
        }

        if (!patch.colors) {
          var colorsStep = card.querySelector('[data-step="colors"]');
          addInlineError(colorsStep, 'Selecciona el número de colores.');
          if (!firstErrorTarget) firstErrorTarget = colorsStep;
          errorMessages.push(prefix + ': faltan los colores');
        }

        if (!patch.shape) {
          var shapeStep = card.querySelector('[data-step="shape"]');
          addInlineError(shapeStep, 'Selecciona la forma del parche.');
          if (!firstErrorTarget) firstErrorTarget = shapeStep;
          errorMessages.push(prefix + ': falta la forma');
        }

        if (!patch.application) {
          var applicationStep = card.querySelector('[data-step="application"]');
          addInlineError(applicationStep, 'Selecciona cómo quieres aplicar el parche.');
          if (!firstErrorTarget) firstErrorTarget = applicationStep;
          errorMessages.push(prefix + ': falta elegir el acabado');
        }
      });

      if (firstErrorTarget) {
        scrollToValidationError(firstErrorTarget);
        throw new Error(
          'Revisa los campos marcados en rojo. ' + errorMessages.join(' · ')
        );
      }
    }

    function validateCustomer(modal) {
      clearValidationErrors(modal);
      captureCustomer(modal);

      var firstErrorTarget = null;

      if (!state.customer.name) {
        var nameInput = modal.querySelector('[name="customerName"]');
        var nameField = nameInput && nameInput.closest('.ba-field');
        addInlineError(nameField, 'Indica tu nombre.');
        if (!firstErrorTarget) firstErrorTarget = nameField;
      }

      if (
        !state.customer.email ||
        state.customer.email.indexOf('@') === -1
      ) {
        var emailInput = modal.querySelector('[name="customerEmail"]');
        var emailField = emailInput && emailInput.closest('.ba-field');
        addInlineError(emailField, 'Indica un correo válido.');
        if (!firstErrorTarget) firstErrorTarget = emailField;
      }

      if (firstErrorTarget) {
        scrollToValidationError(firstErrorTarget);
        throw new Error('Revisa los campos marcados en rojo.');
      }
    }

    function bindPatchEvents(modal) {
      captureCustomer(modal);

      if (!state.customer.name) {
        throw new Error('Indica tu nombre.');
      }

      if (
        !state.customer.email ||
        state.customer.email.indexOf('@') === -1
      ) {
        throw new Error('Indica un correo válido.');
      }
    }

    function bindPatchEvents(app, card, patch) {
      function clearCardErrors() {
        card.querySelectorAll('.ba-validation-error').forEach(function (node) {
          node.classList.remove('ba-validation-error');
        });
        card.querySelectorAll('.ba-inline-error').forEach(function (node) {
          node.remove();
        });
        var status = app.querySelector('[data-status]');
        if (status) {
          status.className = 'ba-status';
          status.textContent = '';
        }
      }

      card.querySelectorAll('[data-difficulty-examples]').forEach(function (link) {
        function showDifficultyExamples(event) {
          event.preventDefault();
          event.stopPropagation();
          openDifficultyExamples(link.getAttribute('data-difficulty-examples'));
        }

        link.addEventListener('click', showDifficultyExamples);
        link.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            showDifficultyExamples(event);
          }
        });
      });

      card.querySelectorAll('[data-difficulty]').forEach(function (button) {
        button.addEventListener('click', function () {
          clearCardErrors();
          patch.difficulty = button.getAttribute('data-difficulty') || 'media';
          saveState(state);
          render();
        });
      });

      card.querySelectorAll('[data-colors]').forEach(function (button) {
        button.addEventListener('click', function () {
          clearCardErrors();
          patch.colors = button.getAttribute('data-colors') || '1_2';
          saveState(state);
          render();
        });
      });

      card.querySelectorAll('[data-shape]').forEach(function (button) {
        button.addEventListener('click', function () {
          clearCardErrors();
          patch.shape = button.getAttribute('data-shape') || 'redondo';

          if (
            patch.shape === 'redondo' ||
            patch.shape === 'cuadrado'
          ) {
            patch.heightCm = patch.widthCm;
          }

          saveState(state);
          render();
        });
      });

      card.querySelectorAll('[data-application]').forEach(function (button) {
        button.addEventListener('click', function () {
          clearCardErrors();
          patch.application = button.getAttribute('data-application') || '';
          saveState(state);
          render();
        });
      });

      card.querySelectorAll('[data-key]').forEach(function (input) {
        var eventName = input.tagName === 'TEXTAREA' ? 'input' : 'change';

        input.addEventListener(eventName, function () {
          clearCardErrors();
          var key = input.getAttribute('data-key');
          var value = input.value;

          if (key === 'quantity') {
            value = Math.max(
              CONFIG.MIN_QUANTITY,
              Math.floor(Number(value || 1))
            );
          }

          if (key === 'widthCm' || key === 'heightCm') {
            value = clampNumber(
              value,
              CONFIG.MIN_SIZE_CM,
              CONFIG.MAX_SIZE_CM,
              CONFIG.DEFAULT_SIZE_CM
            );

            if (
              (patch.shape === 'redondo' ||
               patch.shape === 'cuadrado') &&
              key === 'widthCm'
            ) {
              patch.heightCm = value;
            }

            if (
              (patch.shape === 'redondo' ||
               patch.shape === 'cuadrado') &&
              key === 'heightCm'
            ) {
              patch.widthCm = value;
            }
          }

          patch[key] = value;
          saveState(state);

          if (key !== 'notes') {
            render();
          }
        });
      });

      var minus = card.querySelector('[data-qty-minus]');
      var plus = card.querySelector('[data-qty-plus]');

      if (minus) {
        minus.addEventListener('click', function () {
          clearCardErrors();
          patch.quantity = Math.max(
            CONFIG.MIN_QUANTITY,
            Math.floor(Number(patch.quantity || 1)) - 1
          );
          saveState(state);
          render();
        });
      }

      if (plus) {
        plus.addEventListener('click', function () {
          clearCardErrors();
          patch.quantity = Math.max(
            CONFIG.MIN_QUANTITY,
            Math.floor(Number(patch.quantity || 1)) + 1
          );
          saveState(state);
          render();
        });
      }

      var fileInput = card.querySelector('[data-file]');

      if (fileInput) {
        fileInput.addEventListener('change', function () {
          clearCardErrors();
          var file = fileInput.files && fileInput.files[0];
          if (!file) return;

          var name = card.querySelector('[data-upload-name]');
          if (name) name.textContent = 'Subiendo archivo…';

          fileInput.disabled = true;

          uploadToCloudinary(file)
            .then(function (data) {
              patch.logoUrl = data.secure_url;
              patch.logoName = file.name;
              patch.logoFingerprint = fingerprintFile(file);

              saveState(state);
              render();
            })
            .catch(function (error) {
              alert(error.message);

              if (name) {
                name.textContent =
                  patch.logoName ||
                  'No se pudo subir el archivo';
              }
            })
            .finally(function () {
              fileInput.disabled = false;
            });
        });
      }

      var removeLogo = card.querySelector('[data-remove-logo]');

      if (removeLogo) {
        removeLogo.addEventListener('click', function () {
          patch.logoUrl = '';
          patch.logoName = '';
          patch.logoFingerprint = '';
          patch.difficulty = '';
          patch.colors = '';
          patch.shape = '';
          patch.application = '';
          saveState(state);
          render();
        });
      }

      var remove = card.querySelector('[data-remove]');

      if (remove) {
        remove.addEventListener('click', function () {
          state.patches = state.patches.filter(function (item) {
            return item.id !== patch.id;
          });

          if (!state.patches.length) {
            state.patches.push(blankPatch());
          }

          saveState(state);
          render();
        });
      }
    }

    function render() {
      root.innerHTML = '';

      var allPatchesComplete = state.patches.length > 0 && state.patches.every(isPatchComplete);
      var addDisabledAttributes = allPatchesComplete
        ? ''
        : ' disabled aria-disabled="true" title="Completa los cinco pasos antes de añadir otro diseño"';

      var app = document.createElement('div');
      app.className = 'ba-patches-v2';

      app.innerHTML =
        '<header class="ba-patches-hero">' +
          '<div>' +
            '<span class="ba-patches-kicker">🧵 Parches bordados personalizados</span>' +
            '<h1>Configura tus parches</h1>' +
            '<p>Elige dificultad, colores, forma, tamaño y cantidad. ' +
              'Te mostramos una estimación automática y después revisamos tu diseño antes del pago.</p>' +
          '</div>' +

          '<button type="button" class="ba-patches-btn ba-patches-btn--ghost" data-add' + addDisabledAttributes + '>' +
            '+ Añadir otro diseño' +
          '</button>' +
        '</header>' +

        '<div class="ba-patches-list" data-list></div>' +

        '<div class="ba-add-design-bottom">' +
          '<button type="button" class="ba-patches-btn ba-patches-btn--ghost" data-add-bottom' + addDisabledAttributes + '>' +
            '+ Añadir otro diseño' +
          '</button>' +
        '</div>' +

        '<div class="ba-order-summary ba-order-summary--summary-only">' +
          '<div data-global-summary>' +
            globalSummaryHtml(state) +
          '</div>' +
        '</div>' +

        '<div class="ba-customer-modal" data-customer-modal aria-hidden="true">' +
          '<div class="ba-customer-modal__backdrop" data-modal-close></div>' +
          '<div class="ba-customer-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="baCustomerModalTitle">' +
            '<button type="button" class="ba-customer-modal__close" data-modal-close aria-label="Cerrar">×</button>' +
            '<div class="ba-customer-modal__head">' +
              '<span class="ba-customer-modal__icon">✓</span>' +
              '<div>' +
                '<small>Último paso</small>' +
                '<h2 id="baCustomerModalTitle">Tus datos</h2>' +
                '<p>Te enviaremos aquí la revisión y el presupuesto definitivo.</p>' +
              '</div>' +
            '</div>' +

            '<div class="ba-customer-grid ba-customer-modal__grid">' +
              customerField('Nombre', 'customerName', state.customer.name, 'text') +
              customerField('Apellidos', 'customerLastName', state.customer.lastName, 'text') +
              customerField('Correo', 'customerEmail', state.customer.email, 'email') +
              customerField('Teléfono', 'customerPhone', state.customer.phone, 'tel') +
              customerField('Empresa (opcional)', 'customerCompany', state.customer.company, 'text') +
            '</div>' +

            '<div class="ba-customer-modal__note">' +
              'Revisaremos tus diseños antes de generar el pago. No se cobrará nada en este paso.' +
            '</div>' +

            '<div class="ba-customer-modal__status" data-modal-status></div>' +

            '<div class="ba-customer-modal__actions">' +
              '<button type="button" class="ba-patches-btn ba-patches-btn--secondary" data-modal-close>Volver</button>' +
              '<button type="button" class="ba-patches-btn ba-patches-btn--primary" data-confirm-send>' +
                'Confirmar y enviar para revisión' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';

      root.appendChild(app);

      var list = app.querySelector('[data-list]');
      var modal = app.querySelector('[data-customer-modal]');

      state.patches.forEach(function (patch, index) {
        var holder = document.createElement('div');
        holder.innerHTML = patchHtml(
          patch,
          index,
          state.patches.length
        );

        var card = holder.firstElementChild;
        list.appendChild(card);

        bindPatchEvents(app, card, patch);
      });

      function addPatchAndScroll() {
        if (!state.patches.length || !state.patches.every(isPatchComplete)) return;

        var newPatch = blankPatch();
        state.patches.push(newPatch);
        saveState(state);
        render();

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            var newCard = root.querySelector('[data-patch-id="' + newPatch.id + '"]');
            if (!newCard) return;

            newCard.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });

            newCard.classList.add('ba-patch-v2--just-added');

            setTimeout(function () {
              newCard.classList.remove('ba-patch-v2--just-added');
            }, 1600);
          });
        });
      }

      var addTopButton = app.querySelector('[data-add]');
      var addBottomButton = app.querySelector('[data-add-bottom]');

      if (addTopButton) {
        addTopButton.addEventListener('click', addPatchAndScroll);
      }

      if (addBottomButton) {
        addBottomButton.addEventListener('click', addPatchAndScroll);
      }

      function openModal() {
        if (!modal) return;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('ba-patches-modal-open');

        var first = modal.querySelector('[name="customerName"]');
        if (first) setTimeout(function () { first.focus(); }, 30);
      }

      function closeModal() {
        if (!modal) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('ba-patches-modal-open');
      }

      function showModalStatus(message, ok) {
        var status = modal && modal.querySelector('[data-modal-status]');
        if (!status) return;

        status.className =
          'ba-customer-modal__status ' + (ok ? 'is-ok' : 'is-error');
        status.textContent = message;
      }

      app.querySelectorAll('[data-modal-close]').forEach(function (button) {
        button.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function baPatchModalEsc(event) {
        if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) {
          closeModal();
        }
      }, { once: true });

      var sendButton = app.querySelector('[data-send]');

      if (sendButton) {
        sendButton.addEventListener('click', function () {
          try {
            validatePatches(app);
          } catch (error) {
            showStatus(app, error.message, false);
            return;
          }

          openModal();
        });
      }

      var confirmButton = app.querySelector('[data-confirm-send]');

      if (confirmButton) {
        confirmButton.addEventListener('click', function () {
          try {
            validateCustomer(modal);
          } catch (error) {
            showModalStatus(error.message, false);
            return;
          }

          confirmButton.disabled = true;
          confirmButton.textContent = 'Enviando…';

          var order = calculateOrder(state);

          var payload = {
            action: 'create_patch_quote',
            schemaVersion: 2,
            source: 'ba-parches.js',
            createdAt: new Date().toISOString(),

            customer: state.customer,

            estimate: {
              totalUnits: order.units,
              embroideryTotal: order.embroideryTotal,
              picageTotal: order.picageTotal,
              discountTotal: order.discountTotal,
              totalBeforeDiscount: order.totalBeforeDiscount,
              total: order.total
            },

            patches: state.patches.map(function (patch, index) {
              var calc = calculatePatch(patch);

              return {
                patchId: patch.id,
                patchNumber: index + 1,

                logoUrl: patch.logoUrl,
                logoName: patch.logoName,
                logoFingerprint: patch.logoFingerprint,

                difficultyRequested: patch.difficulty,
                colorsRequested: patch.colors,

                shapeRequested: patch.shape,
                applicationRequested: patch.application,
                widthCm: Number(patch.widthCm),
                heightCm: Number(patch.heightCm),

                quantity: Number(patch.quantity),
                notes: patch.notes || '',

                estimatedPricing: {
                  difficultyPrice: calc.difficulty ? calc.difficulty.price : 0,
                  colorSurcharge: calc.colors ? calc.colors.surcharge : 0,
                  sizeSurcharge: calc.sizeSurcharge,
                  applicationSurcharge: calc.applicationSurcharge,
                  originalUnitPrice: calc.originalUnitPrice,
                  discountPercent: calc.discountPercent,
                  unitPrice: calc.unitPrice,
                  embroideryTotal: calc.embroideryTotal,
                  picage: calc.picage,
                  total: calc.total
                }
              };
            })
          };

          post(payload)
            .then(function (data) {
              var reference = data && (data.reference || data.referencia)
                ? (data.reference || data.referencia)
                : '';

              localStorage.removeItem(STORAGE_KEY);

              var dialog = modal.querySelector('.ba-customer-modal__dialog');

              if (dialog) {
                dialog.innerHTML =
                  '<div class="ba-customer-modal__success">' +
                    '<div class="ba-customer-modal__success-icon">✓</div>' +
                    '<h3>Solicitud enviada</h3>' +
                    '<p>Hemos recibido la solicitud de tus parches. Revisaremos los diseños y te enviaremos el presupuesto definitivo antes de generar ningún pago.</p>' +
                    (reference
                      ? '<div class="ba-customer-modal__reference">' + esc(reference) + '</div>'
                      : '') +
                    '<div class="ba-customer-modal__success-note">' +
                      '<strong>Ahora nos toca a nosotros.</strong> Revisaremos dificultad, colores, medidas, acabado y precio. Cuando esté listo recibirás el presupuesto para revisarlo y aceptarlo.' +
                    '</div>' +
                    '<div class="ba-customer-modal__success-actions">' +
                      '<button type="button" class="ba-patches-btn ba-patches-btn--primary" data-success-close>Cerrar</button>' +
                    '</div>' +
                  '</div>';

                var successClose = dialog.querySelector('[data-success-close]');
                if (successClose) {
                  successClose.addEventListener('click', function () {
                    closeModal();
                    render();
                  });
                }
              }
            })
            .catch(function (error) {
              showModalStatus(error.message, false);
              confirmButton.disabled = false;
              confirmButton.textContent = 'Confirmar y enviar para revisión';
            });
        });
      }
    }

    render();
  }

  /* ============================================================
     BOOT
     ============================================================ */

  function boot() {
    var root = document.getElementById('baPatchesApp');

    if (root) {
      mount(root);
    }
  }

  window.BA_PATCHES = {
    mount: mount,
    config: CONFIG,
    calculatePatch: calculatePatch,
    calculateOrder: calculateOrder
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
